// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: case_record.proto

import type { Error, Sort } from './common';

export const protobufPackage = 'compasspb';

/**
 * Action enum defines all possible decision actions that can be executed on case records.
 * Actions are workflow-specific and trigger state transitions, workflow activities, or task assignments.
 */
export enum Action {
  /** ACTION_UNSPECIFIED - Default value, should not be used */
  ACTION_UNSPECIFIED = 0,
  /** ACTION_BV_AUDIT_CALL_WITH_AI - Benefit Verification (BV) workflow actions - triggered during audit phase */
  ACTION_BV_AUDIT_CALL_WITH_AI = 1,
  /** ACTION_BV_AUDIT_CALL_WITH_HUMAN - Assign case for human-powered call */
  ACTION_BV_AUDIT_CALL_WITH_HUMAN = 2,
  /** ACTION_BV_AUDIT_MARK_AS_COMPLETED - Mark audit as completed successfully */
  ACTION_BV_AUDIT_MARK_AS_COMPLETED = 3,
  /** ACTION_BV_AUDIT_MARK_AS_TERMINATED - Terminate audit (case cannot be completed) */
  ACTION_BV_AUDIT_MARK_AS_TERMINATED = 4,
  /** ACTION_PBM_AUDIT_CALL_WITH_AI - PBM (Pharmacy Benefit Manager) workflow actions - for pharmacy benefit verification */
  ACTION_PBM_AUDIT_CALL_WITH_AI = 10,
  /** ACTION_PBM_AUDIT_CALL_WITH_HUMAN - Assign case for human-powered PBM call */
  ACTION_PBM_AUDIT_CALL_WITH_HUMAN = 11,
  /** ACTION_PBM_AUDIT_MARK_AS_COMPLETED - Mark PBM audit as completed */
  ACTION_PBM_AUDIT_MARK_AS_COMPLETED = 12,
  /** ACTION_PBM_AUDIT_MARK_AS_TERMINATED - Terminate PBM audit */
  ACTION_PBM_AUDIT_MARK_AS_TERMINATED = 13,
  /** ACTION_PBM_AUDIT_CANCEL_AI_AUDIT - DEPRECATED (BV-2131): use ACTION_CANCEL_AI_AUDIT (113). Kept for wire compat with in-flight/old clients; still accepted server-side. */
  ACTION_PBM_AUDIT_CANCEL_AI_AUDIT = 101,
  /** ACTION_MEDBV_AUDIT_CALL_WITH_AI - MedBV (Medical Benefit Verification) workflow actions - for medical benefit verification */
  ACTION_MEDBV_AUDIT_CALL_WITH_AI = 14,
  /** ACTION_MEDBV_AUDIT_CALL_WITH_HUMAN - Assign case for human-powered medical call */
  ACTION_MEDBV_AUDIT_CALL_WITH_HUMAN = 15,
  /** ACTION_MEDBV_AUDIT_MARK_AS_COMPLETED - Mark medical BV audit as completed */
  ACTION_MEDBV_AUDIT_MARK_AS_COMPLETED = 16,
  /** ACTION_MEDBV_AUDIT_MARK_AS_TERMINATED - Terminate medical BV audit */
  ACTION_MEDBV_AUDIT_MARK_AS_TERMINATED = 17,
  /** ACTION_REGENERATE_CASE_SUMMARY - Regenerate AI-generated case summary */
  ACTION_REGENERATE_CASE_SUMMARY = 22,
  /** ACTION_MEDBV_ELIGIBILITY_CHECK_RETRY - Retry eligibility check after failure */
  ACTION_MEDBV_ELIGIBILITY_CHECK_RETRY = 36,
  /** ACTION_MEDBV_ELIGIBILITY_CHECK_PROCEED - Proceed despite eligibility check issues */
  ACTION_MEDBV_ELIGIBILITY_CHECK_PROCEED = 37,
  /** ACTION_RECALL_SCHEDULER_AUDIT_CALL_WITH_AI - Recall Scheduler workflow actions - for scheduling patient recall appointments */
  ACTION_RECALL_SCHEDULER_AUDIT_CALL_WITH_AI = 18,
  /** ACTION_RECALL_SCHEDULER_AUDIT_CALL_WITH_HUMAN - Assign case for human-powered recall call */
  ACTION_RECALL_SCHEDULER_AUDIT_CALL_WITH_HUMAN = 19,
  /** ACTION_RECALL_SCHEDULER_AUDIT_MARK_AS_COMPLETED - Mark recall scheduling as completed */
  ACTION_RECALL_SCHEDULER_AUDIT_MARK_AS_COMPLETED = 20,
  /** ACTION_RECALL_SCHEDULER_AUDIT_MARK_AS_TERMINATED - Terminate recall scheduling */
  ACTION_RECALL_SCHEDULER_AUDIT_MARK_AS_TERMINATED = 21,
  /** ACTION_RECALL_SCHEDULER_AUDIT_UPDATE_NOTE - Update patient notes during audit */
  ACTION_RECALL_SCHEDULER_AUDIT_UPDATE_NOTE = 43,
  /** ACTION_RECALL_SCHEDULER_AUDIT_CREATE_TASK - Create follow-up task during audit */
  ACTION_RECALL_SCHEDULER_AUDIT_CREATE_TASK = 44,
  /** ACTION_RECALL_SCHEDULER_AUDIT_SEND_TEXT - Send SMS text message to patient */
  ACTION_RECALL_SCHEDULER_AUDIT_SEND_TEXT = 45,
  /** ACTION_RECALL_SCHEDULER_AUDIT_SEND_EMAIL - Send email to patient */
  ACTION_RECALL_SCHEDULER_AUDIT_SEND_EMAIL = 54,
  /** ACTION_RECALL_SCHEDULER_AUDIT_MARK_AS_INELIGIBLE - Mark case as ineligible for reachout (from human_audit state) */
  ACTION_RECALL_SCHEDULER_AUDIT_MARK_AS_INELIGIBLE = 51,
  /** ACTION_RECALL_SCHEDULER_CALL_REVIEW_COMPLETED - Mark call review as completed successfully */
  ACTION_RECALL_SCHEDULER_CALL_REVIEW_COMPLETED = 38,
  /** ACTION_RECALL_SCHEDULER_CALL_REVIEW_FAILED - Mark call review as failed */
  ACTION_RECALL_SCHEDULER_CALL_REVIEW_FAILED = 39,
  /** ACTION_RECALL_SCHEDULER_CASE_COMPLETION_REVIEW_APPROVED - Approve case completion */
  ACTION_RECALL_SCHEDULER_CASE_COMPLETION_REVIEW_APPROVED = 40,
  /** ACTION_RECALL_SCHEDULER_CASE_COMPLETION_REVIEW_NEEDS_REVISION - Request revisions to case */
  ACTION_RECALL_SCHEDULER_CASE_COMPLETION_REVIEW_NEEDS_REVISION = 41,
  /** ACTION_RECALL_SCHEDULER_CASE_COMPLETION_REVIEW_REJECTED - Reject case completion */
  ACTION_RECALL_SCHEDULER_CASE_COMPLETION_REVIEW_REJECTED = 42,
  /** ACTION_RECALL_SCHEDULER_INELIGIBLE_CASE_COMPLETION_REVIEW_APPROVED - Approve ineligible case completion */
  ACTION_RECALL_SCHEDULER_INELIGIBLE_CASE_COMPLETION_REVIEW_APPROVED = 56,
  /** ACTION_RECALL_SCHEDULER_INELIGIBLE_CASE_COMPLETION_REVIEW_REJECTED - Reject ineligible case completion */
  ACTION_RECALL_SCHEDULER_INELIGIBLE_CASE_COMPLETION_REVIEW_REJECTED = 57,
  /** ACTION_RECALL_SCHEDULER_REACHOUT_INELIGIBLE_CREATE_TASK - Recall Scheduler reachout ineligible actions - for cases in reachout_ineligible state */
  ACTION_RECALL_SCHEDULER_REACHOUT_INELIGIBLE_CREATE_TASK = 47,
  /** ACTION_RECALL_SCHEDULER_REACHOUT_INELIGIBLE_SEND_TEXT - Send SMS text message while in reachout ineligible state */
  ACTION_RECALL_SCHEDULER_REACHOUT_INELIGIBLE_SEND_TEXT = 48,
  /** ACTION_RECALL_SCHEDULER_REACHOUT_INELIGIBLE_UPDATE_INELIGIBILITY_NOTE - Update ineligibility reason note */
  ACTION_RECALL_SCHEDULER_REACHOUT_INELIGIBLE_UPDATE_INELIGIBILITY_NOTE = 49,
  /** ACTION_RECALL_SCHEDULER_REACHOUT_INELIGIBLE_MARK_AS_ELIGIBLE - Mark case as eligible for reachout */
  ACTION_RECALL_SCHEDULER_REACHOUT_INELIGIBLE_MARK_AS_ELIGIBLE = 50,
  /** ACTION_RECALL_SCHEDULER_REACHOUT_INELIGIBLE_MARK_AS_TERMINATED - Terminate recall scheduling (from reachout_ineligible state) */
  ACTION_RECALL_SCHEDULER_REACHOUT_INELIGIBLE_MARK_AS_TERMINATED = 52,
  /** ACTION_MEDICARE_HUMAN_AUDIT_MARK_AS_COMPLETED - Medicare Human workflow actions - for human-assisted Medicare benefit verification */
  ACTION_MEDICARE_HUMAN_AUDIT_MARK_AS_COMPLETED = 23,
  /** ACTION_MEDICARE_HUMAN_AUDIT_MARK_AS_TERMINATED - Terminate Medicare audit */
  ACTION_MEDICARE_HUMAN_AUDIT_MARK_AS_TERMINATED = 24,
  /** ACTION_MEDICARE_HUMAN_AUDIT_RETRY_CALL - Retry Medicare verification call */
  ACTION_MEDICARE_HUMAN_AUDIT_RETRY_CALL = 25,
  /** ACTION_MEDICARE_HUMAN_CALL_MARK_AS_COMPLETED - Mark Medicare call as completed */
  ACTION_MEDICARE_HUMAN_CALL_MARK_AS_COMPLETED = 26,
  /** ACTION_MEDICARE_HUMAN_CALL_MARK_AS_FAILED - Mark Medicare call as failed */
  ACTION_MEDICARE_HUMAN_CALL_MARK_AS_FAILED = 27,
  /** ACTION_MEDICARE_HUMAN_ELIGIBILITY_CHECK_RETRY - Retry Medicare eligibility check */
  ACTION_MEDICARE_HUMAN_ELIGIBILITY_CHECK_RETRY = 32,
  /** ACTION_MEDICARE_HUMAN_ELIGIBILITY_CHECK_PROCEED - Proceed despite eligibility check issues */
  ACTION_MEDICARE_HUMAN_ELIGIBILITY_CHECK_PROCEED = 33,
  /** ACTION_MEDICARE_HUMAN_MARK_CASE_COMPLETED - Mark Medicare case as directly completed (bypass secondary phase) */
  ACTION_MEDICARE_HUMAN_MARK_CASE_COMPLETED = 46,
  /** ACTION_REFERRAL_SCHEDULER_AUDIT_CALL_WITH_AI - Referral Scheduler workflow actions - for scheduling patient referrals */
  ACTION_REFERRAL_SCHEDULER_AUDIT_CALL_WITH_AI = 28,
  /** ACTION_REFERRAL_SCHEDULER_AUDIT_CALL_WITH_HUMAN - Assign case for human-powered referral call */
  ACTION_REFERRAL_SCHEDULER_AUDIT_CALL_WITH_HUMAN = 29,
  /** ACTION_REFERRAL_SCHEDULER_AUDIT_MARK_AS_COMPLETED - Mark referral scheduling as completed */
  ACTION_REFERRAL_SCHEDULER_AUDIT_MARK_AS_COMPLETED = 30,
  /** ACTION_REFERRAL_SCHEDULER_AUDIT_MARK_AS_TERMINATED - Terminate referral scheduling */
  ACTION_REFERRAL_SCHEDULER_AUDIT_MARK_AS_TERMINATED = 31,
  /** ACTION_REFERRAL_SCHEDULER_AUDIT_UPDATE_NOTE - Update patient notes during audit */
  ACTION_REFERRAL_SCHEDULER_AUDIT_UPDATE_NOTE = 72,
  /** ACTION_REFERRAL_SCHEDULER_AUDIT_CREATE_TASK - Create follow-up task during audit */
  ACTION_REFERRAL_SCHEDULER_AUDIT_CREATE_TASK = 73,
  /** ACTION_REFERRAL_SCHEDULER_AUDIT_SEND_TEXT - Send SMS text message to patient */
  ACTION_REFERRAL_SCHEDULER_AUDIT_SEND_TEXT = 74,
  /** ACTION_REFERRAL_SCHEDULER_AUDIT_SEND_EMAIL - Send email to patient */
  ACTION_REFERRAL_SCHEDULER_AUDIT_SEND_EMAIL = 75,
  /** ACTION_REFERRAL_SCHEDULER_FAX_VERIFICATION_MARK_FAX_AS_INELIGIBLE - Mark fax as ineligible during fax verification */
  ACTION_REFERRAL_SCHEDULER_FAX_VERIFICATION_MARK_FAX_AS_INELIGIBLE = 76,
  /** ACTION_REFERRAL_SCHEDULER_FAX_VERIFICATION_CONFIRM_AND_CONTINUE - Confirm fax verification and continue processing */
  ACTION_REFERRAL_SCHEDULER_FAX_VERIFICATION_CONFIRM_AND_CONTINUE = 77,
  /** ACTION_REFERRAL_SCHEDULER_FAX_INELIGIBLE_MARK_FAX_AS_ELIGIBLE - Mark fax as eligible (from fax ineligible state) */
  ACTION_REFERRAL_SCHEDULER_FAX_INELIGIBLE_MARK_FAX_AS_ELIGIBLE = 78,
  /** ACTION_REFERRAL_SCHEDULER_FAX_INELIGIBLE_MARK_AS_TERMINATED - Terminate case from fax ineligible state */
  ACTION_REFERRAL_SCHEDULER_FAX_INELIGIBLE_MARK_AS_TERMINATED = 79,
  /** ACTION_REFERRAL_SCHEDULER_CASE_COMPLETION_REVIEW_APPROVED - Approve case completion review */
  ACTION_REFERRAL_SCHEDULER_CASE_COMPLETION_REVIEW_APPROVED = 80,
  /** ACTION_REFERRAL_SCHEDULER_CASE_COMPLETION_REVIEW_NEEDS_REVISION - Request revisions during case completion review */
  ACTION_REFERRAL_SCHEDULER_CASE_COMPLETION_REVIEW_NEEDS_REVISION = 81,
  /** ACTION_REFERRAL_SCHEDULER_CASE_COMPLETION_REVIEW_REJECTED - Reject case completion review */
  ACTION_REFERRAL_SCHEDULER_CASE_COMPLETION_REVIEW_REJECTED = 82,
  /** ACTION_REFERRAL_SCHEDULER_CALL_REVIEW_COMPLETED - Mark call review as completed successfully */
  ACTION_REFERRAL_SCHEDULER_CALL_REVIEW_COMPLETED = 83,
  /** ACTION_REFERRAL_SCHEDULER_CALL_REVIEW_REJECTED - Reject call review */
  ACTION_REFERRAL_SCHEDULER_CALL_REVIEW_REJECTED = 84,
  /** ACTION_REFERRAL_SCHEDULER_INELIGIBLE_MARK_AS_ELIGIBLE - Mark case as eligible (from ineligible state) */
  ACTION_REFERRAL_SCHEDULER_INELIGIBLE_MARK_AS_ELIGIBLE = 85,
  /** ACTION_REFERRAL_SCHEDULER_INELIGIBLE_MARK_AS_TERMINATED - Terminate case from ineligible state */
  ACTION_REFERRAL_SCHEDULER_INELIGIBLE_MARK_AS_TERMINATED = 86,
  /** ACTION_REFERRAL_SCHEDULER_PRE_PROCESSING_FAILED_CONFIRM_AND_CONTINUE - Confirm and continue after pre-processing failure */
  ACTION_REFERRAL_SCHEDULER_PRE_PROCESSING_FAILED_CONFIRM_AND_CONTINUE = 87,
  /** ACTION_REFERRAL_SCHEDULER_PRE_REACHOUT_REVIEW_APPROVE_FOR_CALL - Approve case for calling during pre-reachout review */
  ACTION_REFERRAL_SCHEDULER_PRE_REACHOUT_REVIEW_APPROVE_FOR_CALL = 88,
  /** ACTION_REFERRAL_SCHEDULER_PRE_REACHOUT_REVIEW_MARK_AS_INELIGIBLE - Mark case as ineligible during pre-reachout review */
  ACTION_REFERRAL_SCHEDULER_PRE_REACHOUT_REVIEW_MARK_AS_INELIGIBLE = 89,
  /** ACTION_REFERRAL_SCHEDULER_AUDIT_CLOSE_REFERRAL_FAX - Close referral fax during human audit */
  ACTION_REFERRAL_SCHEDULER_AUDIT_CLOSE_REFERRAL_FAX = 90,
  /** ACTION_REFERRAL_SCHEDULER_MISSING_INPUT_COMPLETED - Complete missing input and continue from missing input failure state */
  ACTION_REFERRAL_SCHEDULER_MISSING_INPUT_COMPLETED = 91,
  /** ACTION_REFERRAL_SCHEDULER_PRE_PROCESSING_FAILED_MARK_AS_INELIGIBLE - Mark case as ineligible from pre-processing failed state */
  ACTION_REFERRAL_SCHEDULER_PRE_PROCESSING_FAILED_MARK_AS_INELIGIBLE = 92,
  /** ACTION_PQC_SUBMIT_FOR_REVIEW - PQC (Product Quality Complaint) workflow actions - for adverse event reporting */
  ACTION_PQC_SUBMIT_FOR_REVIEW = 34,
  /** ACTION_PQC_SUBMIT_TO_MANUFACTURER - Submit PQC to manufacturer (after review completion) */
  ACTION_PQC_SUBMIT_TO_MANUFACTURER = 35,
  /** ACTION_PQC_MARK_AS_COMPLETED - Mark PQC case as completed (when ack_id received from manufacturer) */
  ACTION_PQC_MARK_AS_COMPLETED = 53,
  /** ACTION_PQC_MARK_AS_DUPLICATE - Mark PQC case as duplicate */
  ACTION_PQC_MARK_AS_DUPLICATE = 58,
  /** ACTION_PQC_RESEND_EMAIL - Resend form email to manufacturer (from submitted or acknowledged state) */
  ACTION_PQC_RESEND_EMAIL = 59,
  /** ACTION_PQC_ATTACH_TO_CASE - Attach a specific call to the PQC case (sends attach-to-case signal to workflow) */
  ACTION_PQC_ATTACH_TO_CASE = 60,
  /** ACTION_PQC_START_PORTAL_SESSION - Start a Browserbase portal session for manufacturer submission */
  ACTION_PQC_START_PORTAL_SESSION = 93,
  /** ACTION_PQC_CLOSE_PORTAL_SESSION - Close an active Browserbase portal session */
  ACTION_PQC_CLOSE_PORTAL_SESSION = 94,
  /** ACTION_PQC_UPDATE_OUTPUT - Update PQC output field (routes through hermes + PQCAgent) */
  ACTION_PQC_UPDATE_OUTPUT = 95,
  /**
   * ACTION_UNIFIEDMEDBV_AUDIT_MARK_AS_COMPLETED - UnifiedMedBV (Unified Medical Benefit Verification) workflow actions
   * Human Audit actions (5 decision options)
   */
  ACTION_UNIFIEDMEDBV_AUDIT_MARK_AS_COMPLETED = 61,
  /** ACTION_UNIFIEDMEDBV_AUDIT_MARK_AS_TERMINATED - Mark human audit as terminated */
  ACTION_UNIFIEDMEDBV_AUDIT_MARK_AS_TERMINATED = 62,
  /** ACTION_UNIFIEDMEDBV_AUDIT_REINITIATE_AI_CALL - Reinitiate AI call */
  ACTION_UNIFIEDMEDBV_AUDIT_REINITIATE_AI_CALL = 63,
  /** ACTION_UNIFIEDMEDBV_AUDIT_MOVE_TO_HUMAN_CALL - Move to human call */
  ACTION_UNIFIEDMEDBV_AUDIT_MOVE_TO_HUMAN_CALL = 64,
  /** ACTION_UNIFIEDMEDBV_AUDIT_MOVE_TO_MEDICARE - Move to medicare coverage */
  ACTION_UNIFIEDMEDBV_AUDIT_MOVE_TO_MEDICARE = 65,
  /** ACTION_UNIFIEDMEDBV_EC_REINITIATE_EC - EC Human Audit actions (6 decision options) */
  ACTION_UNIFIEDMEDBV_EC_REINITIATE_EC = 66,
  /** ACTION_UNIFIEDMEDBV_EC_MOVE_TO_AI_CALL - Move to AI call */
  ACTION_UNIFIEDMEDBV_EC_MOVE_TO_AI_CALL = 67,
  /** ACTION_UNIFIEDMEDBV_EC_MOVE_TO_HUMAN_CALL - Move to human call */
  ACTION_UNIFIEDMEDBV_EC_MOVE_TO_HUMAN_CALL = 68,
  /** ACTION_UNIFIEDMEDBV_EC_MOVE_TO_MEDICARE - Move to medicare coverage */
  ACTION_UNIFIEDMEDBV_EC_MOVE_TO_MEDICARE = 69,
  /** ACTION_UNIFIEDMEDBV_EC_COMPLETE - Complete workflow */
  ACTION_UNIFIEDMEDBV_EC_COMPLETE = 70,
  /** ACTION_UNIFIEDMEDBV_EC_TERMINATE - Terminate workflow */
  ACTION_UNIFIEDMEDBV_EC_TERMINATE = 71,
  /**
   * ACTION_BHO_AUDIT_MARK_AS_COMPLETED - BHO (Behavioral Health Organization) workflow actions (BV-2171).
   * BHO is a human-only fork of unifiedmedbv with its own nomos schema; its
   * human_audit offers the same 5 decisions, so it gets its own action family
   * rather than reusing the unifiedmedbv one.
   */
  ACTION_BHO_AUDIT_MARK_AS_COMPLETED = 114,
  /** ACTION_BHO_AUDIT_MARK_AS_TERMINATED - Mark human audit as terminated */
  ACTION_BHO_AUDIT_MARK_AS_TERMINATED = 115,
  /** ACTION_BHO_AUDIT_REINITIATE_AI_CALL - Reinitiate AI call */
  ACTION_BHO_AUDIT_REINITIATE_AI_CALL = 116,
  /** ACTION_BHO_AUDIT_MOVE_TO_HUMAN_CALL - Move to human call */
  ACTION_BHO_AUDIT_MOVE_TO_HUMAN_CALL = 117,
  /** ACTION_BHO_AUDIT_MOVE_TO_MEDICARE - Move to medicare coverage */
  ACTION_BHO_AUDIT_MOVE_TO_MEDICARE = 118,
  /**
   * ACTION_MEDBHOBV_AUDIT_MARK_AS_COMPLETED - MEDBHOBV (Med+BH) workflow actions (BV-2328).
   * MEDBHOBV is a human-only clone of bho on its own task queue; its human_audit
   * offers the same 5 decisions, so it gets its own action family, as bho does.
   */
  ACTION_MEDBHOBV_AUDIT_MARK_AS_COMPLETED = 119,
  /** ACTION_MEDBHOBV_AUDIT_MARK_AS_TERMINATED - Mark human audit as terminated */
  ACTION_MEDBHOBV_AUDIT_MARK_AS_TERMINATED = 120,
  /** ACTION_MEDBHOBV_AUDIT_REINITIATE_AI_CALL - Reinitiate AI call */
  ACTION_MEDBHOBV_AUDIT_REINITIATE_AI_CALL = 121,
  /** ACTION_MEDBHOBV_AUDIT_MOVE_TO_HUMAN_CALL - Move to human call */
  ACTION_MEDBHOBV_AUDIT_MOVE_TO_HUMAN_CALL = 122,
  /** ACTION_MEDBHOBV_AUDIT_MOVE_TO_MEDICARE - Move to medicare coverage */
  ACTION_MEDBHOBV_AUDIT_MOVE_TO_MEDICARE = 123,
  /** ACTION_TRANSPORTATION_AUDIT_CALL_WITH_AI - Transportation workflow actions - for transportation benefit verification */
  ACTION_TRANSPORTATION_AUDIT_CALL_WITH_AI = 96,
  /** ACTION_TRANSPORTATION_AUDIT_CALL_WITH_HUMAN - Assign case for human-powered transportation call */
  ACTION_TRANSPORTATION_AUDIT_CALL_WITH_HUMAN = 97,
  /** ACTION_TRANSPORTATION_AUDIT_MARK_AS_COMPLETED - Mark transportation audit as completed */
  ACTION_TRANSPORTATION_AUDIT_MARK_AS_COMPLETED = 98,
  /** ACTION_TRANSPORTATION_AUDIT_MARK_AS_TERMINATED - Terminate transportation audit */
  ACTION_TRANSPORTATION_AUDIT_MARK_AS_TERMINATED = 99,
  /** ACTION_TRANSPORTATION_HUMAN_CALL_MOVE_TO_HUMAN_AUDIT - A Program Admin moves a transportation human call to human audit instead of completing it (BV-2514); the only human_call -> human_audit edge in transportation v4 */
  ACTION_TRANSPORTATION_HUMAN_CALL_MOVE_TO_HUMAN_AUDIT = 127,
  /** ACTION_UNIFIEDMEDBV_HUMAN_CALL_MOVE_TO_HUMAN_AUDIT - A Program Admin moves a unifiedmedbv human call to human audit instead of completing it (BV-2657); the only human_call -> human_audit edge in unifiedmedbv v4 */
  ACTION_UNIFIEDMEDBV_HUMAN_CALL_MOVE_TO_HUMAN_AUDIT = 128,
  /** ACTION_PA_STATUS_PBM_AUDIT_MARK_AS_COMPLETED - PA-Status PBM workflow actions - human audit decisions (BI-1447; map to hermes human-audit-completed) */
  ACTION_PA_STATUS_PBM_AUDIT_MARK_AS_COMPLETED = 104,
  /** ACTION_PA_STATUS_PBM_AUDIT_MOVE_TO_HUMAN_CALL - Human audit rejected -> move to human call */
  ACTION_PA_STATUS_PBM_AUDIT_MOVE_TO_HUMAN_CALL = 105,
  /** ACTION_PA_STATUS_PBM_AUDIT_MARK_AS_TERMINATED - Human audit cannot proceed -> terminate */
  ACTION_PA_STATUS_PBM_AUDIT_MARK_AS_TERMINATED = 106,
  /** ACTION_PA_STATUS_PBM_AUDIT_CALL_WITH_AI - Human audit needs revision -> route to AI call (BI-1658) */
  ACTION_PA_STATUS_PBM_AUDIT_CALL_WITH_AI = 110,
  /** ACTION_PA_STATUS_MEDBV_AUDIT_MARK_AS_COMPLETED - PA-Status MedBV workflow actions - human audit decisions (BI-1447; map to hermes human-audit-completed) */
  ACTION_PA_STATUS_MEDBV_AUDIT_MARK_AS_COMPLETED = 107,
  /** ACTION_PA_STATUS_MEDBV_AUDIT_MOVE_TO_HUMAN_CALL - Human audit rejected -> move to human call */
  ACTION_PA_STATUS_MEDBV_AUDIT_MOVE_TO_HUMAN_CALL = 108,
  /** ACTION_PA_STATUS_MEDBV_AUDIT_MARK_AS_TERMINATED - Human audit cannot proceed -> terminate */
  ACTION_PA_STATUS_MEDBV_AUDIT_MARK_AS_TERMINATED = 109,
  /** ACTION_PA_STATUS_MEDBV_AUDIT_CALL_WITH_AI - Human audit needs revision -> route to AI call (BI-1658) */
  ACTION_PA_STATUS_MEDBV_AUDIT_CALL_WITH_AI = 111,
  /**
   * ACTION_REFILL_CANCEL_SCHEDULED_CALL - Refill workflow actions (JNJ-109)
   *
   * Cancels the SCHEDULED retry attempt of a parked refill case, out of
   * call_scheduled. It maps to the jnj-flows FSM's cancel-ai-call-scheduled
   * signal, which terminates the case.
   *
   * Deliberately NOT ACTION_CANCEL_CALL, even though both are "cancel a call" in
   * English. ACTION_CANCEL_CALL hangs up a call that is RINGING and lets the case
   * carry on; this one ends the case. Overloading one action with both outcomes,
   * switched on case state, is what made ending a call terminate a case (JNJ-109),
   * so the two stay separate actions with separate preconditions.
   */
  ACTION_REFILL_CANCEL_SCHEDULED_CALL = 112,
  /**
   * ACTION_REFILL_HUMAN_AUDIT_RETRY - Release a refill case parked in human_audit_needed (JNJ-172). The FSM parks
   * there when CareTend enrichment, time-zone resolution or the delivery-ticket
   * create fails past its retry cap, and waits with no timeout for one of these.
   * The action's optional note is forwarded as the signal's StringValue payload.
   *
   * RETRY maps to human-audit-retry: re-run the failed step, which re-reads the
   * case record, so input/output edits made while parked are picked up.
   */
  ACTION_REFILL_HUMAN_AUDIT_RETRY = 124,
  /**
   * ACTION_REFILL_HUMAN_AUDIT_SKIP - SKIP maps to human-audit-skip: move past the failed step. A skipped
   * enrichment continues to screening and the call without CareTend data; a
   * skipped delivery ticket COMPLETES the case with no ticket created.
   */
  ACTION_REFILL_HUMAN_AUDIT_SKIP = 125,
  /**
   * ACTION_REFILL_MARK_CASE_AS_COMPLETED - Complete a refill case parked in human_call_needed once a person has called
   * the patient. Maps to mark-case-as-completed; the FSM waits there with no
   * timeout for it and moves the case to completed. The note rides along as the
   * signal's StringValue payload, as for the human-audit actions.
   */
  ACTION_REFILL_MARK_CASE_AS_COMPLETED = 126,
  /** ACTION_HUMAN_CALL_MARK_AS_COMPLETED - Common actions applicable to all workflows */
  ACTION_HUMAN_CALL_MARK_AS_COMPLETED = 5,
  /** ACTION_HUMAN_CALL_MARK_AS_TERMINATED - Mark human-assisted call as terminated */
  ACTION_HUMAN_CALL_MARK_AS_TERMINATED = 6,
  /** ACTION_REASSIGN_TASK - Reassign task to a different user */
  ACTION_REASSIGN_TASK = 7,
  /** ACTION_CANCEL_CALL - Cancel the current call */
  ACTION_CANCEL_CALL = 8,
  /** ACTION_CANCEL_WORKFLOW - Cancel the entire workflow execution */
  ACTION_CANCEL_WORKFLOW = 9,
  /** ACTION_CALCULATE_DISPOSITION - Signal the standalone disposition-calculation workflow to recompute disposition from current output (hermes AD-2089); fired by UI after output save on human_audit for pbm/medbv/unifiedmedbv/transportation */
  ACTION_CALCULATE_DISPOSITION = 100,
  /** ACTION_MANUAL_TASK_STARTED - Informational lifecycle marker: a user started working the manual task (hermes PR #820 / BI-913); fired by UI on input edit (missing-info), output edit (human-audit), and dialer open (human-call) */
  ACTION_MANUAL_TASK_STARTED = 102,
  /** ACTION_START_HUMAN_AUDIT - Starts a human-audit session (BI-1246): creates an in-progress AUDIT_TYPE_HUMAN entity snapshotting current output_data as the diff baseline, then signals hermes (human-audit-in-progress) to set human_audit_in_progress=true (BI-1323). Load-bearing (unlike ACTION_MANUAL_TASK_STARTED) — fails loudly. */
  ACTION_START_HUMAN_AUDIT = 103,
  /** ACTION_CANCEL_AI_AUDIT - Cancel an in-flight AI audit (of an AI or human call) and roll back to human_audit. Generic across all workflows (BV-2131); supersedes the pbm-only ACTION_PBM_AUDIT_CANCEL_AI_AUDIT (101). */
  ACTION_CANCEL_AI_AUDIT = 113,
}

/**
 * CaseExportView selects how much of each case record ExportCaseRecords returns.
 * It is an explicit, enumerated projection toggle (not a client-controlled field
 * mask) per the proto field-design rules.
 */
export enum CaseExportView {
  /** CASE_EXPORT_VIEW_UNSPECIFIED - Unspecified — treated as CASE_EXPORT_VIEW_EXPORT by the service. */
  CASE_EXPORT_VIEW_UNSPECIFIED = 0,
  /**
   * CASE_EXPORT_VIEW_EXPORT - Trimmed case incl. input_data.data + output_data.data (values only, no
   * metadata/schema_version) — for the dashboard CSV/XLSX export.
   */
  CASE_EXPORT_VIEW_EXPORT = 1,
  /**
   * CASE_EXPORT_VIEW_LIVENESS - Scalar liveness fields only (no input_data/output_data) — for the external
   * monitoring service.
   */
  CASE_EXPORT_VIEW_LIVENESS = 2,
}

/** SearchField defines the allowed fields for Atlas Search autocomplete queries. */
export enum SearchField {
  /** SEARCH_FIELD_UNSPECIFIED - Default unspecified value */
  SEARCH_FIELD_UNSPECIFIED = 0,
  /** SEARCH_FIELD_REPORTER_PHONE - Search by reporter phone number */
  SEARCH_FIELD_REPORTER_PHONE = 1,
  /** SEARCH_FIELD_PAYOR_NAME - Search by payor/insurance name */
  SEARCH_FIELD_PAYOR_NAME = 2,
  /** SEARCH_FIELD_PATIENT_FULL_NAME - Search by patient full name */
  SEARCH_FIELD_PATIENT_FULL_NAME = 3,
  /** SEARCH_FIELD_AGENT_NAME - Search by agent name */
  SEARCH_FIELD_AGENT_NAME = 4,
  /** SEARCH_FIELD_FIRST_NAME - Search by patient first name */
  SEARCH_FIELD_FIRST_NAME = 5,
  /** SEARCH_FIELD_PRIMARY_PAYER_NAME - Search by primary payer/insurance name */
  SEARCH_FIELD_PRIMARY_PAYER_NAME = 6,
  /** SEARCH_FIELD_PRIMARY_PHONE - Search by primary insurance phone number */
  SEARCH_FIELD_PRIMARY_PHONE = 7,
  /** SEARCH_FIELD_PRIMARY_MEMBER_ID - Search by primary member ID */
  SEARCH_FIELD_PRIMARY_MEMBER_ID = 8,
  /** SEARCH_FIELD_SECONDARY_MEMBER_ID - Search by secondary member ID */
  SEARCH_FIELD_SECONDARY_MEMBER_ID = 9,
  /** SEARCH_FIELD_PRACTICE_NAME - Search by practice name */
  SEARCH_FIELD_PRACTICE_NAME = 10,
  /** SEARCH_FIELD_J_CODE - Search by drug J code */
  SEARCH_FIELD_J_CODE = 11,
  /** SEARCH_FIELD_DRUG_NAME - Search by drug name */
  SEARCH_FIELD_DRUG_NAME = 12,
  /** SEARCH_FIELD_PROVIDER_FIRST_NAME - Search by provider first name */
  SEARCH_FIELD_PROVIDER_FIRST_NAME = 13,
  /** SEARCH_FIELD_PHONE - Search by insurance phone number */
  SEARCH_FIELD_PHONE = 14,
  /** SEARCH_FIELD_MEMBER_ID - Search by member ID */
  SEARCH_FIELD_MEMBER_ID = 15,
  /** SEARCH_FIELD_NPI - Search by prescriber NPI */
  SEARCH_FIELD_NPI = 16,
  /** SEARCH_FIELD_CLIENT_REFERENCE_NUMBER - Search by client reference number */
  SEARCH_FIELD_CLIENT_REFERENCE_NUMBER = 17,
  /** SEARCH_FIELD_MRN - Search by MRN */
  SEARCH_FIELD_MRN = 18,
  /** SEARCH_FIELD_PROVIDER_LAST_NAME - Search by provider last name */
  SEARCH_FIELD_PROVIDER_LAST_NAME = 19,
  /** SEARCH_FIELD_DATE_OF_SERVICE - Search by date of service */
  SEARCH_FIELD_DATE_OF_SERVICE = 20,
  /** SEARCH_FIELD_LAST_NAME - Search by patient last name */
  SEARCH_FIELD_LAST_NAME = 21,
  /** SEARCH_FIELD_CASE_TYPE - Search by case type (AE or PQC) */
  SEARCH_FIELD_CASE_TYPE = 22,
  /** SEARCH_FIELD_PHONE_MOBILE - Search by mobile phone number (input_data.data.phone_mobile) */
  SEARCH_FIELD_PHONE_MOBILE = 23,
  /** SEARCH_FIELD_PHONE_HOME - Search by home phone number (input_data.data.phone_home) */
  SEARCH_FIELD_PHONE_HOME = 24,
  /** SEARCH_FIELD_REACHOUT_ELIGIBILITY_STATUS - Search by reachout eligibility status (input_data.data.reachout_eligibility_status) */
  SEARCH_FIELD_REACHOUT_ELIGIBILITY_STATUS = 25,
  /** SEARCH_FIELD_INELIGIBILITY_TAG - Search by ineligibility tag (input_data.data.ineligibility_tag) */
  SEARCH_FIELD_INELIGIBILITY_TAG = 26,
  /** SEARCH_FIELD_MEDICAL_RECORD_NUMBER - Search by medical record number (input_data.data.medical_record_number) */
  SEARCH_FIELD_MEDICAL_RECORD_NUMBER = 27,
  /**
   * SEARCH_FIELD_PAYER_NAME - Search by payer name (input_data.data.payer_name) — transportation workflow uses this
   * spelling (vs payor_name used by PharmBV).
   */
  SEARCH_FIELD_PAYER_NAME = 28,
  /** SEARCH_FIELD_ACK_ID - Search by manufacturer acknowledgement id (output_data.data.ack_id) — PQC. */
  SEARCH_FIELD_ACK_ID = 29,
  /**
   * SEARCH_FIELD_PQC_DECISION - Search by PQC manufacturer-reply decision (output_data.data.decision):
   * acknowledged / question_asked / missing_info.
   */
  SEARCH_FIELD_PQC_DECISION = 30,
  /**
   * SEARCH_FIELD_PATIENT_FIRST_NAME - Search by PA-Status patient first name (input_data.data.patient_first_name).
   * Distinct from SEARCH_FIELD_FIRST_NAME (5), which is the flat
   * input_data.data.first_name used by the transportation/scheduler workflows.
   */
  SEARCH_FIELD_PATIENT_FIRST_NAME = 31,
  /**
   * SEARCH_FIELD_PATIENT_LAST_NAME - Search by PA-Status patient last name (input_data.data.patient_last_name).
   * Distinct from SEARCH_FIELD_LAST_NAME (21) — see above.
   */
  SEARCH_FIELD_PATIENT_LAST_NAME = 32,
  /**
   * SEARCH_FIELD_PATIENT_MEMBER_ID - Search by PA-Status patient member ID (input_data.data.patient_member_id).
   * Distinct from SEARCH_FIELD_MEMBER_ID (15) — see above.
   */
  SEARCH_FIELD_PATIENT_MEMBER_ID = 33,
  /** SEARCH_FIELD_DRUG_NDC - Search by drug NDC (input_data.data.drug_ndc) — pa_status_pbm / refill. */
  SEARCH_FIELD_DRUG_NDC = 34,
  /**
   * SEARCH_FIELD_J_CODES_CODE - Search by J code inside the j_codes array (input_data.data.j_codes.code) —
   * pa_status_medbv. Distinct from SEARCH_FIELD_J_CODE (11), which is the flat
   * input_data.data.j_code used by the BV workflows.
   */
  SEARCH_FIELD_J_CODES_CODE = 35,
  /**
   * SEARCH_FIELD_CPT_CODES_CODE - Search by CPT code inside the cpt_codes array (input_data.data.cpt_codes.code)
   * — pa_status_medbv.
   */
  SEARCH_FIELD_CPT_CODES_CODE = 36,
  /**
   * SEARCH_FIELD_PA_STATUS - PA Status — output_data.data.prior_authorization_on_file_status, and
   * output_data.data.{drug,procedure}.prior_auth_status.prior_authorization_on_file_status.
   * Values are PaFollowUpStatus enum names (e.g. PA_FOLLOW_UP_STATUS_APPROVED).
   */
  SEARCH_FIELD_PA_STATUS = 37,
  /**
   * SEARCH_FIELD_PA_REQUIRED - PA Required — output_data.data.prior_authorization_required, and
   * output_data.data.{drug,procedure}.prior_auth_status.prior_authorization_required.
   * Values are the YesNo keys (yes / no).
   */
  SEARCH_FIELD_PA_REQUIRED = 38,
  /**
   * SEARCH_FIELD_PA_ON_FILE_EXISTS - PA on File Exists — output_data.data.prior_authorization_on_file_exists, and
   * output_data.data.{drug,procedure}.prior_auth_status.prior_authorization_on_file_exists.
   */
  SEARCH_FIELD_PA_ON_FILE_EXISTS = 39,
  /**
   * SEARCH_FIELD_APPEAL_AVAILABLE - Appeal Available — output_data.data.appeal_available, and
   * output_data.data.{drug,procedure}.prior_auth_denied.appeal_available. On medbv the
   * appeal block hangs off the DENIED subsection, not off prior_auth_status.
   */
  SEARCH_FIELD_APPEAL_AVAILABLE = 40,
  /**
   * SEARCH_FIELD_APPEAL_STATUS - Appeal Status — output_data.data.appeal_status, and
   * output_data.data.{drug,procedure}.prior_auth_denied.appeal_status.
   * Values are AppealStatus enum names (e.g. APPEAL_STATUS_DENIED).
   */
  SEARCH_FIELD_APPEAL_STATUS = 41,
  /**
   * SEARCH_FIELD_SEPERATE_BHO_POLICY - Separate BHO Policy — output_data.data.seperate_bho_policy (BV-2505), the BHO
   * field recording whether behavioral health is carved out to its own policy.
   * Values are the YesNoUnknown keys (yes / no / unknown). Offered in the BHO
   * Cases search dropdown; like the other output fields it is a substring match on
   * case_record_output_data_search, so no index change is needed. The key keeps the
   * schema's "seperate" spelling.
   */
  SEARCH_FIELD_SEPERATE_BHO_POLICY = 42,
}

/**
 * SearchMatchType selects how an OutputFieldCondition's value(s) are matched in
 * Atlas $search. Default (PREFIX) preserves the existing autocomplete behavior.
 */
export enum SearchMatchType {
  /** SEARCH_MATCH_TYPE_UNSPECIFIED - Prefix/autocomplete wildcard match (default — existing behavior). */
  SEARCH_MATCH_TYPE_UNSPECIFIED = 0,
  /** SEARCH_MATCH_TYPE_EXISTS - Field is present and non-empty (values ignored). */
  SEARCH_MATCH_TYPE_EXISTS = 1,
  /** SEARCH_MATCH_TYPE_NOT_EXISTS - Field is absent or empty (values ignored). */
  SEARCH_MATCH_TYPE_NOT_EXISTS = 2,
  /** SEARCH_MATCH_TYPE_EXACT - Field exactly equals any of values (token match, OR within values). */
  SEARCH_MATCH_TYPE_EXACT = 3,
  /** SEARCH_MATCH_TYPE_NOT_EXACT - Field does not exactly equal any of values (token mustNot, AND). */
  SEARCH_MATCH_TYPE_NOT_EXACT = 4,
}

/**
 * SearchSortField is the explicit sort allow-list for the output-data advanced
 * search (used only by the PQC submitted-substate tabs: Submitted / Follow-up
 * Required / Ready to Complete). Scoped to that PQC surface — the other tabs use
 * the standard FindCaseRecords path. No client-controlled field paths.
 */
export enum SearchSortField {
  /** SEARCH_SORT_FIELD_UNSPECIFIED - Default — no custom sort (falls back to _id desc). */
  SEARCH_SORT_FIELD_UNSPECIFIED = 0,
  /** SEARCH_SORT_FIELD_SUBMITTED_AT - → state_updated_at (equals submitted_at while the case is in the submitted state). */
  SEARCH_SORT_FIELD_SUBMITTED_AT = 1,
  /** SEARCH_SORT_FIELD_ACK_RECEIVED_AT - → output_data.data.ack_received_at (ISO-8601 string; populated by PQCAgent). */
  SEARCH_SORT_FIELD_ACK_RECEIVED_AT = 2,
  /** SEARCH_SORT_FIELD_FOLLOW_UP_REQUESTED_AT - → output_data.data.follow_up_requested_at (ISO-8601 string; populated by PQCAgent). */
  SEARCH_SORT_FIELD_FOLLOW_UP_REQUESTED_AT = 3,
}

/**
 * WorkflowState enum represents the current execution state of a Temporal workflow.
 * These states track the lifecycle of workflow execution from start to completion or cancellation.
 */
export enum WorkflowState {
  /** WORKFLOW_STATE_UNSPECIFIED - Default value, should not be used */
  WORKFLOW_STATE_UNSPECIFIED = 0,
  /** WORKFLOW_STATE_STOPPED - Workflow is stopped or has not been started yet */
  WORKFLOW_STATE_STOPPED = 1,
  /** WORKFLOW_STATE_WAITING - Workflow is waiting for external input (e.g., manual task completion, user decision) */
  WORKFLOW_STATE_WAITING = 2,
  /** WORKFLOW_STATE_RUNNING - Workflow is actively executing activities */
  WORKFLOW_STATE_RUNNING = 3,
  /** WORKFLOW_STATE_PAUSED - Workflow is temporarily paused (can be resumed) */
  WORKFLOW_STATE_PAUSED = 4,
  /** WORKFLOW_STATE_COMPLETED - Workflow completed successfully with all tasks finished */
  WORKFLOW_STATE_COMPLETED = 5,
  /** WORKFLOW_STATE_CANCELLED - Workflow was explicitly cancelled by user or system */
  WORKFLOW_STATE_CANCELLED = 6,
  /** WORKFLOW_STATE_CREATED - Workflow is created but not started */
  WORKFLOW_STATE_CREATED = 7,
}

/** WatchEventType indicates the type of change event for a watched resource. */
export enum WatchEventType {
  WATCH_EVENT_TYPE_UNSPECIFIED = 0,
  /** WATCH_EVENT_TYPE_UPDATED - Case record was updated */
  WATCH_EVENT_TYPE_UPDATED = 1,
  /** WATCH_EVENT_TYPE_DELETED - Case record was deleted */
  WATCH_EVENT_TYPE_DELETED = 2,
  /** WATCH_EVENT_TYPE_INITIAL - Initial state of the case record when watch is established */
  WATCH_EVENT_TYPE_INITIAL = 3,
  /** WATCH_EVENT_TYPE_HEARTBEAT - Heartbeat event to keep connection alive */
  WATCH_EVENT_TYPE_HEARTBEAT = 4,
}

/** AuditEntryType indicates whether the audit entry contains a full snapshot or delta. */
export enum AuditEntryType {
  AUDIT_ENTRY_TYPE_UNSPECIFIED = 0,
  /** AUDIT_ENTRY_TYPE_FULL - Full document snapshot */
  AUDIT_ENTRY_TYPE_FULL = 1,
  /** AUDIT_ENTRY_TYPE_DELTA - Only changed fields */
  AUDIT_ENTRY_TYPE_DELTA = 2,
}

/** AuditActorType indicates whether the action was performed by a user or service. */
export enum AuditActorType {
  AUDIT_ACTOR_TYPE_UNSPECIFIED = 0,
  /** AUDIT_ACTOR_TYPE_USER - Action performed by a user */
  AUDIT_ACTOR_TYPE_USER = 1,
  /** AUDIT_ACTOR_TYPE_SERVICE - Action performed by a service */
  AUDIT_ACTOR_TYPE_SERVICE = 2,
}

/**
 * CreateCaseRecordRequest represents the request to create a new case record.
 * Case records are the primary work items that flow through workflows.
 */
export interface CreateCaseRecordRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  workflow_id?: string | undefined;
  reference_id?: string | undefined;
  input_data?: CaseRecordData | undefined;
  /**
   * Files attached to File-type input fields. Populated only on the multipart create path
   * (Manual Case Creation); empty for JSON requests. Each entry is uploaded to Arcus after the
   * case is created and its asset ID is written to input_data.data[field_id].
   */
  files?: CaseFileUpload[] | undefined;
}

/** CaseFileUpload carries one file destined for a File-type input field during case creation. */
export interface CaseFileUpload {
  field_id?: string | undefined;
  /** Complete file data (multipart part) */
  data?: Uint8Array | undefined;
  filename?: string | undefined;
  content_type?: string | undefined;
}

/** CreateCaseRecordResponse returns the ID of the newly created case record. */
export interface CreateCaseRecordResponse {
  case_record_id?: string | undefined;
}

/** GetCaseRecordsByWorkflowRequest retrieves case records for a specific workflow with extensive filtering and pagination options. */
export interface GetCaseRecordsByWorkflowRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  workflow_id?: string | undefined;
  /** Query parameters for filtering */
  created_at_before?: string | undefined;
  created_at_after?: string | undefined;
  status?: string[] | undefined;
  reference_id?: string[] | undefined;
  limit?: number | undefined;
  case_id?: string[] | undefined;
  assigned?: string[] | undefined;
  start_after_id?: string | undefined;
  campaign_id?: string | undefined;
  /** @deprecated */
  nested_filters?: NestedFieldFilter[] | undefined;
  /** @deprecated */
  sort_fields?: SortField[] | undefined;
}

/** GetCaseRecordsByWorkflowResponse returns a paginated list of case records matching the filter criteria. */
export interface GetCaseRecordsByWorkflowResponse {
  case_records?: GetCaseRecordResponse[] | undefined;
  /** @deprecated */
  total_count?: number | undefined;
}

/**
 * GetCurrentUserAssignedCaseRecordsRequest retrieves all case records assigned to the authenticated user.
 * User ID is automatically determined from authentication context.
 * ListMyOrganizationCasesRequest filters case records assigned to the authenticated user
 * across all programs in an organization. [AD-2203]
 */
export interface ListMyOrganizationCasesRequest {
  /** Organization ID (path parameter) */
  organization_id?: string | undefined;
  /** Optional program IDs filter; if empty, includes all programs in the org. */
  program_ids?: string[] | undefined;
  /** Optional case record IDs filter; if empty, no case-record ID filter is applied. */
  case_record_ids?: string[] | undefined;
  /** Filter records created after this timestamp (exclusive). */
  created_after?: string | undefined;
  /** Filter records created before this timestamp (exclusive). */
  created_before?: string | undefined;
  /** Pagination limit (default 50, max 100). */
  limit?: number | undefined;
  /** Cursor-based pagination - case record ID to start after. */
  start_after_id?: string | undefined;
}

/** ListMyOrganizationCasesResponse returns a paginated list of cases assigned to the authenticated user. */
export interface ListMyOrganizationCasesResponse {
  /** List of case records assigned to the authenticated user. */
  case_records?: GetCaseRecordResponse[] | undefined;
  /** Cursor for fetching the next page (empty if no more results). */
  next_cursor?: string | undefined;
}

export interface GetCurrentUserAssignedCaseRecordsRequest {
  /** Organization ID to filter case records by (optional, from path) */
  organization_id?: string | undefined;
  /** Program ID to filter case records by (optional) */
  program_id?: string | undefined;
  /** Workflow ID to filter case records by (optional) */
  workflow_id?: string | undefined;
  /** Filter records created before this timestamp */
  created_at_before?: string | undefined;
  /** Filter records created after this timestamp */
  created_at_after?: string | undefined;
  /** Multiple status filters (e.g., 'created', 'in_progress', 'completed') */
  status?: string[] | undefined;
  /** Maximum number of records to return (default: 100, max: 1000) */
  limit?: number | undefined;
  /** Cursor-based pagination - start after this case record ID */
  start_after_id?: string | undefined;
  /** Fields to sort by with priority */
  sort_fields?: SortField[] | undefined;
}

/** GetCurrentUserAssignedCaseRecordsResponse returns a paginated list of case records assigned to the authenticated user. */
export interface GetCurrentUserAssignedCaseRecordsResponse {
  /** List of case records assigned to the authenticated user */
  case_records?: GetCaseRecordResponse[] | undefined;
  /**
   * Total number of records matching the filter (for pagination)
   *
   * @deprecated
   */
  total_count?: number | undefined;
}

/** GetCaseRecordRequest retrieves a single case record by its unique identifier. */
export interface GetCaseRecordRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
}

/** GetCaseRecordResponse returns complete details of a case record including workflow state, timestamps, and assignments. */
export interface GetCaseRecordResponse {
  id?: string | undefined;
  code?: string | undefined;
  reference_id?: string | undefined;
  state?: string | undefined;
  input_data?: CaseRecordData | undefined;
  status_flags?: StatusFlags | undefined;
  assigned?: string | undefined;
  assigned_by?: string | undefined;
  manager?: string | undefined;
  updated_by?: string | undefined;
  output_data?: CaseRecordData | undefined;
  created_at?: string | undefined;
  completed_at?: string | undefined;
  assigned_at?: string | undefined;
  updated_at?: string | undefined;
  cancelled_by?: string | undefined;
  cancelled_at?: string | undefined;
  atlas_sid?: string | undefined;
  program_id?: string | undefined;
  state_updated_at?: string | undefined;
  organization_id?: string | undefined;
  workflow_state?: WorkflowState | undefined;
  workflow_started_at?: string | undefined;
  workflow_last_started_at?: string | undefined;
  workflow_duration_seconds?: number | undefined;
  workflow_completed_at?: string | undefined;
  workflow_cancelled_at?: string | undefined;
  error?: Error | undefined;
  creation_method?: string | undefined;
  active_call_id?: string | undefined;
  assigned_user_id?: string | undefined;
  team_id?: string | undefined;
  linked_case_record_ids?: string[] | undefined;
  workflow_type?: string | undefined;
  /** Disposition code referencing dispositions.code */
  disposition_code?: number | undefined;
  /**
   * Scheduled tasks - map of task name to scheduled timestamp (UTC).
   * Only contains pending tasks; completed/cancelled tasks are removed.
   */
  scheduled_tasks?: { [key: string]: string } | undefined;
  /**
   * Computed expiration timestamp for the workflow (created_at + workflow expiry duration).
   * Not persisted; computed on-the-fly from workflow model expiry or default (7 days).
   */
  workflow_expires_at?: string | undefined;
  workflow_id?: string | undefined;
  created_by?: string | undefined;
  /** AI-extracted data synced from calls - contains fields extracted from transcripts */
  extracted_data?: CaseExtractedData | undefined;
  /** Disposition label and engine context (type, required/missing/ok-if-N/A fields, notes). The code is disposition_code. */
  disposition?: CaseRecordDisposition | undefined;
  /**
   * Number of AI call records on this case. Not persisted; counted from the
   * calls collection at read time, and only on the endpoints that render it.
   */
  ai_call_attempts?: number | undefined;
  /**
   * Number of human call records on this case. Not persisted; counted from the
   * calls collection at read time, alongside ai_call_attempts.
   */
  human_call_attempts?: number | undefined;
  /**
   * When the latest human call record on this case was created. Not persisted;
   * read from the calls collection alongside human_call_attempts. Unset when
   * the case has no human call.
   */
  last_human_call_at?: string | undefined;
}

export interface GetCaseRecordResponse_ScheduledTasksEntry {
  key: string;
  value?: string | undefined;
}

/**
 * DEPRECATED: Use UpdateAssignedRequest instead
 *
 * @deprecated
 */
export interface UpdateCaseRecordRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  /** user_id, updated by dashboard using API */
  assigned?: string | undefined;
  /** ObjectID of the assigned user (optional) */
  assigned_user_id?: string | undefined;
  /** ObjectID of the team (optional) */
  team_id?: string | undefined;
  clear_error?: boolean | undefined;
}

/**
 * DEPRECATED: Use UpdateAssignedResponse instead
 *
 * @deprecated
 */
export interface UpdateCaseRecordResponse {
  case_record?: GetCaseRecordResponse | undefined;
}

/** CancelCaseRecordRequest cancels a case record and stops workflow execution. */
export interface CancelCaseRecordRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
}

/** CancelCaseRecordResponse returns the cancelled case record details. */
export interface CancelCaseRecordResponse {
  case_record?: GetCaseRecordResponse | undefined;
}

/** UpdateAssignedRequest updates the user assignment for a case record. */
export interface UpdateAssignedRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  /**
   * DEPRECATED: Use assigned_user_id instead. Kept for backward compatibility.
   *
   * @deprecated
   */
  assigned?: string | undefined;
  /** User ID to assign the case record to (preferred over deprecated 'assigned' field) */
  assigned_user_id?: string | undefined;
  /** Optional note to create with this assignment change (creates an assignment_changed note) */
  note?: ActionNoteData | undefined;
  /**
   * Optional. When set, the case is also moved to this team. The assignee must
   * be a member of this team, and the team must serve the case's workflow type
   * within the case's program (catch-all teams without a workflow type are not
   * allowed for manual assignment). When empty, the case keeps its current team
   * and the assignee is validated against it.
   */
  team_id?: string | undefined;
}

/** UpdateAssignedResponse returns the updated case record and the previous assignment. */
export interface UpdateAssignedResponse {
  case_record?: GetCaseRecordResponse | undefined;
  previous_assigned?: string | undefined;
}

/** UpdateOutputDataRequest updates the output data for a case record, optionally marking it as completed. */
export interface UpdateOutputDataRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  output_data?: CaseRecordData | undefined;
  mark_completed?: boolean | undefined;
}

/** UpdateOutputDataResponse returns the updated case record with new output data. */
export interface UpdateOutputDataResponse {
  case_record?: GetCaseRecordResponse | undefined;
}

/** UpdateInputDataRequest updates the input data for a case record (used for corrections or additional information). */
export interface UpdateInputDataRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  input_data?: CaseRecordData | undefined;
}

/** UpdateInputDataResponse returns the updated case record with new input data. */
export interface UpdateInputDataResponse {
  case_record?: GetCaseRecordResponse | undefined;
}

/** UpdateDispositionCodeRequest updates the disposition code for a case record. */
export interface UpdateDispositionCodeRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  disposition_code?: number | undefined;
  /** Disposition label and engine context. Optional. Replaces the stored object whole: this request has no field mask. */
  disposition?: CaseRecordDisposition | undefined;
}

/** UpdateDispositionCodeResponse returns the updated case record. */
export interface UpdateDispositionCodeResponse {
  case_record?: GetCaseRecordResponse | undefined;
}

/**
 * ActionData provides action-specific data that varies based on the action type being executed.
 * Different actions require different data payloads for proper execution.
 */
export interface ActionData {
  /** Data for audit decision actions */
  audit_decision?: ActionData_AuditDecisionData | undefined;
  /** Data for human call actions */
  human_call?: ActionData_HumanCallData | undefined;
  /** Data for task reassignment */
  reassign_task?: ActionData_ReassignTaskData | undefined;
  /** Data for call cancellation */
  cancel_call?: ActionData_CancelCallData | undefined;
  /** Data for workflow cancellation */
  cancel_workflow?: ActionData_CancelWorkflowData | undefined;
  /** Data for call review actions */
  call_review?: ActionData_CallReviewData | undefined;
  /** Data for marking case as duplicate */
  mark_as_duplicate?: ActionData_MarkAsDuplicateData | undefined;
  /** Data for attaching a specific call to a case */
  attach_to_case?: ActionData_AttachToCaseData | undefined;
  /** Data for starting a portal session with task tracking */
  start_portal_session?: ActionData_StartPortalSessionData | undefined;
  /** Data for PQC output field update */
  update_output?: ActionData_UpdateOutputData | undefined;
  /** Data for cancelling an in-flight AI audit */
  cancel_ai_audit?: ActionData_CancelAuditData | undefined;
}

/** AuditDecisionData contains information for audit decision actions (mark as completed/terminated). */
export interface ActionData_AuditDecisionData {
  reason?: string | undefined;
  task_id?: string | undefined;
  text_id?: string | undefined;
  email_id?: string | undefined;
  ineligibility_note?: string | undefined;
  ineligibility_tag?: string | undefined;
  scheduled_at?: string | undefined;
  handoff_actions?: ActionData_AuditDecisionData_HandoffAction[] | undefined;
}

/**
 * HandoffAction is one action item a human auditor leaves for the human
 * caller when routing a case back to a human call. Optional and only
 * consumed by route-to-human-call terminal audit actions; persisted onto
 * the AUDIT_TYPE_HUMAN entity at finalize.
 */
export interface ActionData_AuditDecisionData_HandoffAction {
  field?: string | undefined;
  note?: string | undefined;
}

/**
 * HumanCallData contains information for human call actions.
 * Currently empty but can be extended in the future for additional call metadata.
 */
export interface ActionData_HumanCallData {}

/** ReassignTaskData contains information for reassigning a task to a different user. */
export interface ActionData_ReassignTaskData {
  assigned_to?: string | undefined;
  assigned_by?: string | undefined;
}

/** CancelCallData contains the reason for cancelling a call. */
export interface ActionData_CancelCallData {
  reason?: string | undefined;
}

/** CancelWorkflowData contains the reason for cancelling the entire workflow. */
export interface ActionData_CancelWorkflowData {
  reason?: string | undefined;
}

/** CancelAuditData contains the reason for cancelling an in-flight AI audit run. */
export interface ActionData_CancelAuditData {
  reason?: string | undefined;
}

/**
 * CallReviewData contains data for call review actions.
 * Note: review notes are now stored directly on the call record via UpdateCall.
 */
export interface ActionData_CallReviewData {
  /** @deprecated */
  note?: string | undefined;
}

/** MarkAsDuplicateData contains the reason for marking a case as duplicate. */
export interface ActionData_MarkAsDuplicateData {
  reason?: string | undefined;
}

/** AttachToCaseData contains the call ID to attach to a PQC case. */
export interface ActionData_AttachToCaseData {
  call_id?: string | undefined;
}

/** StartPortalSessionData contains the generic task ID for portal session tracking. */
export interface ActionData_StartPortalSessionData {
  task_id?: string | undefined;
}

/** UpdateOutputData contains a map of output fields to update. */
export interface ActionData_UpdateOutputData {
  fields?: { [key: string]: string } | undefined;
}

export interface ActionData_UpdateOutputData_FieldsEntry {
  key: string;
  value: string;
}

/**
 * ActionNoteData contains optional note content to create when performing an action.
 * This allows users to add notes that are automatically associated with state changes or assignments.
 */
export interface ActionNoteData {
  /** Content of the note to create */
  content?: string | undefined;
}

/**
 * ExecuteActionRequest executes a workflow action on a case record.
 * Actions trigger state transitions, workflow activities, or user assignments.
 */
export interface ExecuteActionRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  action?: Action | undefined;
  action_data?: ActionData | undefined;
  /** Optional note to create with this action (creates a state_changed note) */
  note?: ActionNoteData | undefined;
}

/** ExecuteActionResponse indicates whether the action was successfully executed. */
export interface ExecuteActionResponse {
  success?: boolean | undefined;
}

/**
 * DEPRECATED: CountFilter represents a named filter configuration for counting case records.
 * This message will be removed in a future version. Use explicit filter fields in query parameters instead.
 *
 * @deprecated
 */
export interface CountFilter {
  name?: string | undefined;
  filter?: GetCaseRecordsByWorkflowRequest | undefined;
}

/**
 * GetCaseCountsRequest retrieves case counts for a workflow with optional filters.
 * All filter values are passed as query parameters.
 */
export interface GetCaseCountsRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  workflow_id?: string | undefined;
  /** Explicit filter fields */
  status?: string[] | undefined;
  created_at_before?: string | undefined;
  created_at_after?: string | undefined;
  assigned_user_ids?: string[] | undefined;
  campaign_id?: string | undefined;
  group_by_status?: boolean | undefined;
  /** Atlas Search fields for advanced filtering (e.g., patient name, payor name) */
  search_field?: SearchField | undefined;
  search_value?: string | undefined;
  case_record_ids?: string[] | undefined;
  reference_ids?: string[] | undefined;
  case_codes?: string[] | undefined;
  /**
   * Output-field conditions, AND-combined into a compound $search (mirrors
   * SearchCaseRecordsRequest.output_conditions). Lets per-sub-tab counts match
   * the list filter (e.g. submitted + ack_id EXISTS). Empty = no output filter.
   */
  output_conditions?: OutputFieldCondition[] | undefined;
}

/** StatusCount represents count for a specific status. */
export interface StatusCount {
  status?: string | undefined;
  count?: number | undefined;
}

/** GetCaseCountsResponse returns the total count matching the filters. */
export interface GetCaseCountsResponse {
  total_count?: number | undefined;
  groups?: StatusCount[] | undefined;
}

/**
 * GetOrganizationCaseCountsRequest retrieves case counts across an organization,
 * scoped to the caller's accessible programs. Mirrors GetCaseCountsRequest's
 * shared filters but replaces the single program_id/workflow_id with the org sets
 * (program_ids/workflow_ids/workflow_types).
 */
export interface GetOrganizationCaseCountsRequest {
  organization_id?: string | undefined;
  /** Org scoping (matches any). Empty program_ids = all programs the caller can read. */
  program_ids?: string[] | undefined;
  workflow_ids?: string[] | undefined;
  workflow_types?: string[] | undefined;
  /** Shared filters (same semantics as GetCaseCountsRequest). */
  status?: string[] | undefined;
  created_at_before?: string | undefined;
  created_at_after?: string | undefined;
  assigned_user_ids?: string[] | undefined;
  campaign_id?: string | undefined;
  group_by_status?: boolean | undefined;
  search_field?: SearchField | undefined;
  search_value?: string | undefined;
  case_record_ids?: string[] | undefined;
  reference_ids?: string[] | undefined;
  case_codes?: string[] | undefined;
  output_conditions?: OutputFieldCondition[] | undefined;
}

/**
 * GetOrganizationCaseCountsResponse returns org-wide case counts. Same shape as
 * GetCaseCountsResponse — a dedicated type so buf RPC_RESPONSE_STANDARD_NAME
 * passes (the lint rule requires the response be named after the RPC).
 */
export interface GetOrganizationCaseCountsResponse {
  total_count?: number | undefined;
  groups?: StatusCount[] | undefined;
}

/** DeleteCaseRecordRequest represents request to delete a case record */
export interface DeleteCaseRecordRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
}

/** DeleteCaseRecordResponse represents response from deleting a case record */
export interface DeleteCaseRecordResponse {
  success?: boolean | undefined;
  workflow_id?: string | undefined;
  message?: string | undefined;
}

/** BulkDeleteCaseRecordsRequest soft deletes several case records in one program. */
export interface BulkDeleteCaseRecordsRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_ids?: string[] | undefined;
}

/** BulkDeleteCaseRecordResult is the outcome for one case in a bulk delete. */
export interface BulkDeleteCaseRecordResult {
  case_record_id?: string | undefined;
  success?: boolean | undefined;
  error?: string | undefined;
}

/** BulkDeleteCaseRecordsResponse returns one result per requested case, in request order. */
export interface BulkDeleteCaseRecordsResponse {
  results?: BulkDeleteCaseRecordResult[] | undefined;
  deleted_count?: number | undefined;
}

/**
 * DEPRECATED: NestedFieldFilter represents a filter for nested JSON fields in case records.
 * This message will be removed in a future version.
 *
 * @deprecated
 */
export interface NestedFieldFilter {
  field_path?: string | undefined;
  operation?: string | undefined;
  value?: string | undefined;
  case_sensitive?: boolean | undefined;
}

/**
 * DEPRECATED: SortField represents a field to sort by with priority.
 * This message will be removed in a future version.
 *
 * @deprecated
 */
export interface SortField {
  field_path?: string | undefined;
  descending?: boolean | undefined;
  priority?: number | undefined;
}

/** FindCaseRecordsRequest represents the request to find case records with multiple filters */
export interface FindCaseRecordsRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_ids?: string[] | undefined;
  reference_ids?: string[] | undefined;
  states?: string[] | undefined;
  created_at_before?: string | undefined;
  created_at_after?: string | undefined;
  completed_at_before?: string | undefined;
  completed_at_after?: string | undefined;
  limit?: number | undefined;
  campaign_id?: string | undefined;
  team_id?: string | undefined;
  assigned_user_ids?: string[] | undefined;
  workflow_id?: string | undefined;
  payor_name?: string | undefined;
  sort_by_created_at?: Sort | undefined;
  sort_by_payor_name?: Sort | undefined;
  start_after_id?: string | undefined;
  case_codes?: string[] | undefined;
  exclude_states?: string[] | undefined;
  workflow_ids?: string[] | undefined;
  program_ids?: string[] | undefined;
  workflow_types?: string[] | undefined;
}

/** FindCaseRecordsResponse represents the response from finding case records */
export interface FindCaseRecordsResponse {
  case_records?: GetCaseRecordResponse[] | undefined;
  /** @deprecated */
  total_count?: number | undefined;
}

/**
 * ExportCaseRecordsRequest carries the program-scoped filter/pagination subset of
 * FindCaseRecordsRequest, plus the projection view. Field numbers are independent
 * of FindCaseRecordsRequest.
 */
export interface ExportCaseRecordsRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  view?: CaseExportView | undefined;
  states?: string[] | undefined;
  exclude_states?: string[] | undefined;
  case_record_ids?: string[] | undefined;
  reference_ids?: string[] | undefined;
  case_codes?: string[] | undefined;
  workflow_id?: string | undefined;
  workflow_ids?: string[] | undefined;
  workflow_types?: string[] | undefined;
  created_at_before?: string | undefined;
  created_at_after?: string | undefined;
  completed_at_before?: string | undefined;
  completed_at_after?: string | undefined;
  team_id?: string | undefined;
  assigned_user_ids?: string[] | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
  sort_by_created_at?: Sort | undefined;
}

/** ExportCaseRecordsResponse is the reduced list response. */
export interface ExportCaseRecordsResponse {
  case_records?: ExportCaseRecord[] | undefined;
  /**
   * Cursor for the next page: the id of the last record when a full page was
   * returned, empty when there are no more results.
   */
  next_page_token?: string | undefined;
}

/**
 * ExportCaseRecord is the trimmed per-case projection. It deliberately omits
 * output_data.metadata, input_data.metadata, schema_version, extracted_data, and
 * bg_model_output_data — the fields that bloat GetCaseRecordResponse.
 * NOTE: input_data/output_data may contain Protected Health Information (PHI) —
 * handle according to HIPAA compliance requirements.
 */
export interface ExportCaseRecord {
  id?: string | undefined;
  code?: string | undefined;
  reference_id?: string | undefined;
  state?: string | undefined;
  previous_state?: string | undefined;
  assigned?: string | undefined;
  created_by?: string | undefined;
  disposition_code?: number | undefined;
  workflow_state?: WorkflowState | undefined;
  previous_workflow_state?: string | undefined;
  status_flags?: StatusFlags | undefined;
  workflow_id?: string | undefined;
  workflow_type?: string | undefined;
  workflow_duration_seconds?: number | undefined;
  created_at?: string | undefined;
  workflow_started_at?: string | undefined;
  workflow_last_started_at?: string | undefined;
  workflow_paused_at?: string | undefined;
  state_updated_at?: string | undefined;
  workflow_completed_at?: string | undefined;
  workflow_cancelled_at?: string | undefined;
  /** Values only (schema_version/metadata omitted); absent when view=LIVENESS. */
  input_data?: CaseRecordData | undefined;
  output_data?: CaseRecordData | undefined;
}

/**
 * FindOrganizationCaseRecordsRequest is the org-wide case search request. It carries
 * the program-search filter set plus org-only scoping (program_ids/workflow_ids/
 * workflow_types) and the advanced Atlas params (field/value/output_conditions/
 * sort_field/sort_order) the org endpoint serves via Atlas Search. Kept separate from
 * FindCaseRecordsRequest so the program request stays clean (and per buf naming).
 */
export interface FindOrganizationCaseRecordsRequest {
  organization_id?: string | undefined;
  /** Org scoping (matches any). Empty program_ids = all programs the caller can read. */
  program_ids?: string[] | undefined;
  workflow_ids?: string[] | undefined;
  workflow_types?: string[] | undefined;
  /** Shared filters (same semantics as FindCaseRecordsRequest). */
  case_record_ids?: string[] | undefined;
  reference_ids?: string[] | undefined;
  case_codes?: string[] | undefined;
  states?: string[] | undefined;
  exclude_states?: string[] | undefined;
  created_at_before?: string | undefined;
  created_at_after?: string | undefined;
  completed_at_before?: string | undefined;
  completed_at_after?: string | undefined;
  assigned_user_ids?: string[] | undefined;
  campaign_id?: string | undefined;
  team_id?: string | undefined;
  payor_name?: string | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
  sort_by_created_at?: Sort | undefined;
  sort_by_payor_name?: Sort | undefined;
  /**
   * Advanced (Atlas) params: text search (field+value, input_data index) or
   * output_conditions (output_data index) — mutually exclusive — plus advanced sort.
   */
  field?: SearchField | undefined;
  value?: string | undefined;
  output_conditions?: OutputFieldCondition[] | undefined;
  sort_field?: SearchSortField | undefined;
  sort_order?: Sort | undefined;
}

/** FindOrganizationCaseRecordsResponse is the org-wide case search response. */
export interface FindOrganizationCaseRecordsResponse {
  case_records?: GetCaseRecordResponse[] | undefined;
  /**
   * Keyset cursor for the next page (populated only on the Atlas advanced path:
   * output_conditions / advanced sort / free-text). Empty if no more results or on
   * the standard find path (which cursors by last record id via start_after_id).
   */
  next_page_token?: string | undefined;
}

/**
 * OutputFieldCondition is one predicate on an output_data field. Multiple
 * conditions on a request are AND-combined into a compound $search — this lets a
 * tab express e.g. "ack_id EXISTS AND decision NOT_EXACT {question_asked,missing_info}".
 */
export interface OutputFieldCondition {
  /** Output field to match (currently SEARCH_FIELD_ACK_ID / SEARCH_FIELD_PQC_DECISION). */
  field?: SearchField | undefined;
  /** How to match. */
  match_type?: SearchMatchType | undefined;
  /** Values for EXACT / NOT_EXACT (ignored for EXISTS / NOT_EXISTS). */
  values?: string[] | undefined;
}

/** SearchCaseRecordsRequest performs Atlas Search autocomplete on case records. */
export interface SearchCaseRecordsRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  /** Field to search */
  field?: SearchField | undefined;
  /** Value to search for using autocomplete */
  value?: string | undefined;
  /** Filter records created after this timestamp */
  created_at_after?: string | undefined;
  /** Filter records created before this timestamp */
  created_at_before?: string | undefined;
  /** Filter by workflow ID */
  workflow_id?: string | undefined;
  /** Maximum number of results to return (default: 20, max: 100) */
  limit?: number | undefined;
  /** Optional case type filter (e.g., "AE" or "PQC") - combined with AND logic */
  case_type_filter?: string | undefined;
  /** Filter by assigned user IDs (empty string matches unassigned cases) */
  assigned_user_ids?: string[] | undefined;
  /**
   * Filter by case state(s) (applied as a $match after $search). Without this,
   * advanced search returns hits across ALL states. Empty = no state filter.
   */
  states?: string[] | undefined;
  /**
   * Output-field conditions, AND-combined into a compound $search. Lets a tab
   * express e.g. ack_id EXISTS AND decision NOT_EXACT {question_asked,missing_info}.
   * Empty = no output filter (backward-compatible).
   */
  output_conditions?: OutputFieldCondition[] | undefined;
  /**
   * Sort the result list. Default (UNSPECIFIED) keeps legacy _id-descending order.
   * Applied as a post-$search $sort with _id as a tiebreaker.
   */
  sort_field?: SearchSortField | undefined;
  /** Sort direction for sort_field (SORT_ASC / SORT_DESC; default SORT_DESC). */
  sort_order?: Sort | undefined;
  /** Opaque keyset cursor from a previous response's next_page_token. Empty = first page. */
  page_token?: string | undefined;
}

/** SearchCaseRecordsResponse contains Atlas Search results. */
export interface SearchCaseRecordsResponse {
  case_records?: GetCaseRecordResponse[] | undefined;
  /** Keyset cursor for the next page; empty when there are no more results. */
  next_page_token?: string | undefined;
}

/** CreateCaseRecordWithFaxRequest represents the request to create a case record with a fax document */
export interface CreateCaseRecordWithFaxRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  workflow_id?: string | undefined;
  reference_id?: string | undefined;
  fax_file?: Uint8Array | undefined;
  fax_filename?: string | undefined;
  fax_content_type?: string | undefined;
  fax_uuid?: string | undefined;
  fax_received_timestamp?: string | undefined;
}

/** CreateCaseRecordWithFaxResponse represents the response from creating a case record with fax */
export interface CreateCaseRecordWithFaxResponse {
  case_record_id?: string | undefined;
  asset_id?: string | undefined;
}

/** Mark case record as adverse event request */
export interface MarkAsAdverseEventRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  workflow_id?: string | undefined;
}

/** Mark case record as adverse event response */
export interface MarkAsAdverseEventResponse {
  case_record?: CaseRecord | undefined;
  workflow_run_id?: string | undefined;
}

/** Link to case request */
export interface LinkToCaseRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  workflow_id?: string | undefined;
}

/** Link to case response */
export interface LinkToCaseResponse {
  case_record?: CaseRecord | undefined;
  workflow_run_id?: string | undefined;
}

/** Trigger process-recording request */
export interface TriggerProcessRecordingRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  contact_id?: string | undefined;
  master_contact_id?: string | undefined;
  review?: boolean | undefined;
}

/** Trigger process-recording response */
export interface TriggerProcessRecordingResponse {
  case_record?: CaseRecord | undefined;
}

/** Clone case record request - creates a duplicate of an existing case record */
export interface CloneCaseRecordRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  /** Optional: override the reference_id for the cloned case record */
  reference_id?: string | undefined;
}

/** Clone case record response */
export interface CloneCaseRecordResponse {
  case_record_id?: string | undefined;
}

/** MigrateCaseRecordToMedBVRequest represents the request to migrate a case record from medicare_human to medbv workflow. */
export interface MigrateCaseRecordToMedBVRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  target_workflow_id?: string | undefined;
}

/** MigrateCaseRecordToMedBVResponse returns the ID of the newly created medbv case record. */
export interface MigrateCaseRecordToMedBVResponse {
  new_case_record_id?: string | undefined;
  source_case_record_id?: string | undefined;
}

/** StartCaseRecordRequest triggers the workflow for a case record. */
export interface StartCaseRecordRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  restart?: boolean | undefined;
}

/** StartCaseRecordResponse returns the Temporal workflow execution details. */
export interface StartCaseRecordResponse {
  workflow_id?: string | undefined;
  run_id?: string | undefined;
}

/**
 * CaseRecordData represents structured JSON data for case records.
 * Used for both input data (patient/member information) and output data (verification results).
 * NOTE: Protected Health Information (PHI) may be present in this field - handle according to HIPAA compliance requirements.
 */
export interface CaseRecordData {
  schema_version?: string | undefined;
  data?: { [key: string]: any } | undefined;
  metadata?: { [key: string]: any } | undefined;
}

/**
 * CaseExtractedDataSection represents extracted data with associated metadata for case records.
 * Contains both the extracted data and any metadata about the extraction process.
 */
export interface CaseExtractedDataSection {
  /** Extracted data as a JSON structure */
  data?: { [key: string]: any } | undefined;
  /** Metadata about the extraction (e.g., extraction timestamp, source call, confidence) */
  metadata?: { [key: string]: any } | undefined;
}

/**
 * CaseExtractedData contains structured data synced to a case record from calls.
 * Separates input data (reserved for future use) from output data (synced from call extractions).
 */
export interface CaseExtractedData {
  /** Output data synced from call extractions (e.g., from AI transcript analysis) */
  output?: CaseExtractedDataSection | undefined;
  /** Input data (reserved for future use) */
  input?: CaseExtractedDataSection | undefined;
}

/**
 * WorkflowRun represents a single Temporal workflow execution record.
 * Case records may have multiple workflow runs over their lifecycle (e.g., retry attempts, different workflow types).
 */
export interface WorkflowRun {
  workflow_type?: string | undefined;
  workflow_id?: string | undefined;
  run_id?: string | undefined;
}

/**
 * StatusFlags provides boolean flags indicating the current state and available operations for a case record.
 * These flags control UI visibility and API operation permissions.
 */
export interface StatusFlags {
  sla_breach?: boolean | undefined;
  blocked_on_manual_task?: boolean | undefined;
  can_update_input?: boolean | undefined;
  can_update_output?: boolean | undefined;
  can_cancel_call?: boolean | undefined;
  can_cancel_workflow?: boolean | undefined;
  is_summary_generation_in_progress?: boolean | undefined;
  manual_task_in_progress?: boolean | undefined;
  sla_risk_escalated?: boolean | undefined;
  manual_assignment?: boolean | undefined;
  human_audit_in_progress?: boolean | undefined;
  call_stacked?: boolean | undefined;
}

/**
 * CaseRecordDisposition is the disposition engine's last result for a case
 * record: its label (type) and evaluation context, i.e. the output fields the
 * disposition required, the ones still missing, and the ones excused as
 * OK-if-N/A. It carries no code: the case's code is disposition_code on the
 * case record. Field 1 (code) held a copy of it and is retired (BV-2425).
 * A code-only write (dashboard override) does not update type.
 */
export interface CaseRecordDisposition {
  /** Type of disposition (e.g., "completed", "no_answer", "callback_requested") */
  type?: string | undefined;
  /** Timestamp when a callback or follow-up was requested */
  requested_time?: string | undefined;
  /** Additional notes about the disposition */
  notes?: string | undefined;
  /** Output data keys required for a complete disposition (e.g., ["plan_name", "member_id", "group_number"]) */
  required_fields?: string[] | undefined;
  /** Output data keys that are still missing (e.g., ["group_number"]) */
  missing_fields?: string[] | undefined;
  /**
   * OK-if-N/A (BV-2069): the required fields that were blank but did NOT block
   * this disposition, because the audit confirmed the voice agent asked about
   * them. A subset of missing_fields, not a replacement for it — an excused
   * field is still reported missing. Absent and empty are identical and both
   * mean "nothing excused".
   *
   * WARNING: UpdateDispositionCode has no field mask and replaces this whole
   * message. Any writer must pass this field through — bvagent's
   * calculate-disposition response echoes it back for exactly that purpose.
   */
  ok_if_na_asked?: string[] | undefined;
}

/**
 * CaseRecord represents the complete internal data model for a case record.
 * This message is used for database storage and internal operations.
 * NOTE: Contains Protected Health Information (PHI) - handle according to HIPAA compliance requirements.
 * For API responses, use GetCaseRecordResponse instead.
 */
export interface CaseRecord {
  /** Core identifiers (1-2) */
  id?: string | undefined;
  reference_id?: string | undefined;
  /** Core status and data (3-7) */
  state?: string | undefined;
  input_data?: CaseRecordData | undefined;
  status_flags?: StatusFlags | undefined;
  case_record_data?: CaseRecordData | undefined;
  output_data?: CaseRecordData | undefined;
  /** Assignment fields (8-11, 38-39) */
  assigned?: string | undefined;
  assigned_by?: string | undefined;
  manager?: string | undefined;
  updated_by?: string | undefined;
  assigned_user_id?: string | undefined;
  team_id?: string | undefined;
  /** Timestamps (12-17, 20-23, 32-33) */
  created_at?: string | undefined;
  completed_at?: string | undefined;
  assigned_at?: string | undefined;
  updated_at?: string | undefined;
  state_updated_at?: string | undefined;
  workflow_started_at?: string | undefined;
  workflow_last_started_at?: string | undefined;
  workflow_duration_seconds?: number | undefined;
  workflow_completed_at?: string | undefined;
  workflow_cancelled_at?: string | undefined;
  /** Cancellation fields (16, 17, 26) */
  cancelled_by?: string | undefined;
  cancelled_at?: string | undefined;
  cancel_reason?: string | undefined;
  /** Atlas integration (18) */
  atlas_sid?: string | undefined;
  /** Program reference (19) */
  program_id?: string | undefined;
  /** Workflow state (24) */
  workflow_state?: WorkflowState | undefined;
  /** Workflow type (28) */
  workflow_type?: string | undefined;
  /** Workflow definition ID (43) */
  workflow_id?: string | undefined;
  /** Organization reference (25) */
  organization_id?: string | undefined;
  /** Error information (27) */
  error?: Error | undefined;
  /** Workflow runs list (31) */
  workflow_runs?: WorkflowRun[] | undefined;
  /** Active call reference (37) */
  active_call_id?: string | undefined;
  /** Linked case record references (40) */
  linked_case_record_ids?: string[] | undefined;
  /** Disposition code referencing dispositions.code */
  disposition_code?: number | undefined;
  /**
   * Scheduled tasks - map of task name to scheduled timestamp (UTC).
   * Only contains pending tasks; completed/cancelled tasks are removed.
   */
  scheduled_tasks?: { [key: string]: string } | undefined;
  /** Extracted data synced from calls - contains AI-extracted output fields */
  extracted_data?: CaseExtractedData | undefined;
  /** Disposition label and engine context (type, required/missing/ok-if-N/A fields, notes). The code is disposition_code. */
  disposition?: CaseRecordDisposition | undefined;
}

export interface CaseRecord_ScheduledTasksEntry {
  key: string;
  value?: string | undefined;
}

/** WatchCaseRecordsRequest specifies which case records to watch for changes. */
export interface WatchCaseRecordsRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_ids?: string[] | undefined;
}

/** WatchCaseRecordsResponse represents an update event for a watched case record. */
export interface WatchCaseRecordsResponse {
  /** Type of event that occurred */
  event_type?: WatchEventType | undefined;
  /** The updated case record data */
  case_record?: GetCaseRecordResponse | undefined;
  /** Timestamp when the event occurred */
  event_time?: string | undefined;
}

/** GetCaseRecordHistoryRequest retrieves the audit history for a case record. */
export interface GetCaseRecordHistoryRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  /** Maximum number of records to return (default: 50, max: 100) */
  limit?: number | undefined;
  /** Cursor-based pagination - start after this audit record ID */
  start_after_id?: string | undefined;
  /** Filter by actor type (user or service). If unspecified, returns all entries. */
  actor_type?: AuditActorType | undefined;
}

/** GetCaseRecordHistoryResponse returns the audit history for a case record. */
export interface GetCaseRecordHistoryResponse {
  /** List of audit records for the case record, ordered by timestamp descending (most recent first) */
  entries?: CaseRecordAuditEntry[] | undefined;
  /**
   * Cursor for fetching the next page of results. Empty if no more results.
   * Use this value as start_after_id in the next request.
   */
  next_cursor?: string | undefined;
}

/** AuditUserActor represents a user who performed an action. */
export interface AuditUserActor {
  /** User ID who made the change */
  user_id?: string | undefined;
  /** IP address of the client */
  ip_address?: string | undefined;
}

/** AuditServiceActor represents a service that performed an action. */
export interface AuditServiceActor {
  /** Name of the service */
  service_name?: string | undefined;
}

/** AuditActor represents who performed an audited action. */
export interface AuditActor {
  /** Type of actor */
  actor_type?: AuditActorType | undefined;
  /** User actor details */
  user?: AuditUserActor | undefined;
  /** Service actor details */
  service?: AuditServiceActor | undefined;
}

/** CaseRecordAuditEntry represents a single audit trail entry for a case record. */
export interface CaseRecordAuditEntry {
  /** Unique ID of this audit entry */
  id?: string | undefined;
  /** Type of operation: insert, update, replace, delete */
  operation?: string | undefined;
  /** Timestamp when the change occurred */
  timestamp?: string | undefined;
  /** Entry type: full snapshot or delta */
  entry_type?: AuditEntryType | undefined;
  /** Case record snapshot (populated for full entries) */
  case_record?: CaseRecord | undefined;
  /** Fields that were updated (only for delta entries) */
  update_description?: CaseRecordUpdateDescription | undefined;
  /** Who performed this action */
  actor?: AuditActor | undefined;
}

/** CaseRecordUpdateDescription describes what fields were changed in an update. */
export interface CaseRecordUpdateDescription {
  /** Map of field paths to their new values */
  updated_fields?: { [key: string]: any } | undefined;
  /** List of field paths that were removed */
  removed_fields?: string[] | undefined;
}

/**
 * AdminUpdateSLARequest updates SLA-related fields on a case record.
 * All fields are optional — only provided fields are updated.
 *
 * MITIGATION ONLY: This message is part of the admin mitigation API.
 * Do not use in application code, UI features, or automated workflows.
 * See AdminCaseRecordService warning for details.
 */
export interface AdminUpdateSLARequest {
  case_record_id?: string | undefined;
  sla_breach?: boolean | undefined;
  workflow_duration_seconds?: number | undefined;
  workflow_completed_at?: string | undefined;
}

/** AdminUpdateSLAResponse returns the updated case record. */
export interface AdminUpdateSLAResponse {
  case_record?: GetCaseRecordResponse | undefined;
}

/**
 * AdminUpdateCaseStateRequest updates the case state and/or workflow state.
 *
 * MITIGATION ONLY: This message is part of the admin mitigation API, added for
 * LA-4605 (reviving cases wrongly auto-closed by workflow timeouts). It mirrors
 * the internal core UpdateState semantics: state values are workflow-owned
 * strings and are not enumerated here. Do not use in application code, UI
 * features, or automated workflows.
 */
export interface AdminUpdateCaseStateRequest {
  case_record_id?: string | undefined;
  new_state?: string | undefined;
  previous_state?: string | undefined;
  reason?: string | undefined;
  workflow_state?: WorkflowState | undefined;
}

/** AdminUpdateCaseStateResponse returns the state transition that was applied. */
export interface AdminUpdateCaseStateResponse {
  previous_state?: string | undefined;
  state?: string | undefined;
  workflow_state?: WorkflowState | undefined;
}

/**
 * AdminUpdateStatusFlagsRequest updates status flags on a case record.
 * All fields are optional — only provided fields are updated.
 *
 * MITIGATION ONLY: This message is part of the admin mitigation API.
 * Do not use in application code, UI features, or automated workflows.
 * See AdminCaseRecordService warning for details.
 */
export interface AdminUpdateStatusFlagsRequest {
  case_record_id?: string | undefined;
  sla_breach?: boolean | undefined;
  blocked_on_manual_task?: boolean | undefined;
  can_update_input?: boolean | undefined;
  can_update_output?: boolean | undefined;
  can_cancel_call?: boolean | undefined;
  can_cancel_workflow?: boolean | undefined;
  is_summary_generation_in_progress?: boolean | undefined;
}

/** AdminUpdateStatusFlagsResponse returns the updated case record. */
export interface AdminUpdateStatusFlagsResponse {
  case_record?: GetCaseRecordResponse | undefined;
}

/**
 * AdminSearchCaseRecordsRequest is the request for global (cross-organization)
 * case record search. Mirrors SearchCaseRecordsRequest minus organization_id
 * and program_id, plus case_record_ids for direct ID lookup.
 */
export interface AdminSearchCaseRecordsRequest {
  /**
   * When non-empty, performs an ID lookup and skips the Atlas Search stage.
   * Other filters (workflow_id, assigned_user_ids, time bounds, etc.) still
   * apply to the matched records.
   */
  case_record_ids?: string[] | undefined;
  /** Field to autocomplete-search on input_data (Atlas Search). */
  field?: SearchField | undefined;
  /** Autocomplete value paired with `field`. */
  value?: string | undefined;
  /** Filter records created after this timestamp. */
  created_at_after?: string | undefined;
  /** Filter records created before this timestamp. */
  created_at_before?: string | undefined;
  /** Filter by workflow ID. */
  workflow_id?: string | undefined;
  /** Maximum number of results to return (default: 20, max: 100). */
  limit?: number | undefined;
  /** Optional case type filter (e.g., "AE" or "PQC"). */
  case_type_filter?: string | undefined;
  /** Filter by assigned user IDs (empty string matches unassigned cases). */
  assigned_user_ids?: string[] | undefined;
}

/** AdminSearchCaseRecordsResponse mirrors SearchCaseRecordsResponse. */
export interface AdminSearchCaseRecordsResponse {
  case_records?: GetCaseRecordResponse[] | undefined;
}

/** GetCaseRecordTimelineRequest retrieves the activity timeline for a case record. */
export interface GetCaseRecordTimelineRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  /** Maximum number of events to return (default: 50, max: 100) */
  limit?: number | undefined;
  /** Cursor-based pagination - start after this event ID */
  after?: string | undefined;
  /** Filter by event type (e.g. "case.state.changed", "case.call.completed") */
  event_type?: string | undefined;
}

/** GetCaseRecordTimelineResponse returns the activity timeline for a case record. */
export interface GetCaseRecordTimelineResponse {
  /** List of timeline events, ordered newest-first */
  entries?: TimelineEntry[] | undefined;
  /** Cursor for fetching the next page. Empty if no more results. */
  next_cursor?: string | undefined;
}

/** TimelineEntry represents a single event in the case record's activity timeline. */
export interface TimelineEntry {
  /** Unique ID of this timeline entry */
  id?: string | undefined;
  /** Event type (e.g. "case.created", "case.state.changed", "case.call.completed") */
  type?: string | undefined;
  /** User ID who performed the action (empty for system events) */
  actor_id?: string | undefined;
  /** When the event occurred */
  created_at?: string | undefined;
  /** Event-specific detail payload (JSON object, structure varies by type) */
  detail?: { [key: string]: any } | undefined;
  /** Immutable metadata set at append time */
  metadata?: { [key: string]: string } | undefined;
}

export interface TimelineEntry_MetadataEntry {
  key: string;
  value: string;
}

/**
 * CaseRecordsService provides operations for managing case records.
 * Case records are the primary work items that flow through workflows,
 * containing patient/member data and tracking verification progress.
 */
export interface CaseRecordsService {
  /** CreateCaseRecord creates a new case record in the system. */
  createCaseRecord(request: CreateCaseRecordRequest): Promise<CreateCaseRecordResponse>;
  /** FindCaseRecords searches case records with multiple filter options. */
  findCaseRecords(request: FindCaseRecordsRequest): Promise<FindCaseRecordsResponse>;
  /**
   * ExportCaseRecords returns a reduced, purpose-built projection of case
   * records for two consumers that do not need the full case payload: the
   * dashboard CSV/XLSX export (view=EXPORT — trimmed case incl.
   * input_data.data + output_data.data but WITHOUT *.metadata, schema_version,
   * or extracted_data) and an external liveness monitor (view=LIVENESS —
   * scalar liveness fields only, no data maps). Same program scope, filters,
   * and cursor pagination as FindCaseRecords; the heavy output_data.metadata /
   * extracted_data blobs are never transferred.
   */
  exportCaseRecords(request: ExportCaseRecordsRequest): Promise<ExportCaseRecordsResponse>;
  /**
   * FindOrganizationCaseRecords searches case records across all programs in an
   * organization. It supports the same filters as FindCaseRecords, plus
   * multi-program (program_ids) and multi-workflow (workflow_ids) filtering.
   * Callers with org-level case_record:read see the whole org; callers with only
   * program-level access are transparently scoped to the programs they can access.
   */
  findOrganizationCaseRecords(
    request: FindOrganizationCaseRecordsRequest,
  ): Promise<FindOrganizationCaseRecordsResponse>;
  /**
   * GetOrganizationCaseCounts returns case counts across an organization, scoped
   * to the programs the caller can access (mirrors FindOrganizationCaseRecords).
   * Same filters/counts shape as the program-scoped GetCaseCounts, plus the
   * multi-program (program_ids) / multi-workflow (workflow_ids / workflow_types)
   * org filters; no single workflow_id is required. Same shape as
   * GetCaseCountsResponse (dedicated type so buf RPC_RESPONSE_STANDARD_NAME passes).
   */
  getOrganizationCaseCounts(
    request: GetOrganizationCaseCountsRequest,
  ): Promise<GetOrganizationCaseCountsResponse>;
  /**
   * SearchCaseRecords performs autocomplete search on input_data fields using MongoDB Atlas Search.
   * Returns case records where the specified field matches the search value with relevance scoring.
   */
  searchCaseRecords(request: SearchCaseRecordsRequest): Promise<SearchCaseRecordsResponse>;
  /**
   * GetCurrentUserAssignedCaseRecords retrieves all case records assigned to the authenticated user.
   * Returns case records within the specified program, optionally filtered by workflow.
   * User ID is determined from authentication context.
   * ListMyOrganizationCases lists case records assigned to the authenticated user
   * across all programs in an organization. Supports filtering by program_ids,
   * case_record_ids, and creation date range with cursor-based pagination. [AD-2203]
   */
  listMyOrganizationCases(
    request: ListMyOrganizationCasesRequest,
  ): Promise<ListMyOrganizationCasesResponse>;
  getCurrentUserAssignedCaseRecords(
    request: GetCurrentUserAssignedCaseRecordsRequest,
  ): Promise<GetCurrentUserAssignedCaseRecordsResponse>;
  /** GetCaseRecord retrieves a case record by its unique identifier. */
  getCaseRecord(request: GetCaseRecordRequest): Promise<GetCaseRecordResponse>;
  /**
   * GetCaseRecordHistory retrieves the audit history of a case record.
   * Returns a paginated list of audit records showing all changes made to the case record,
   * including who made the change, when, and what fields were modified.
   */
  getCaseRecordHistory(request: GetCaseRecordHistoryRequest): Promise<GetCaseRecordHistoryResponse>;
  /**
   * UpdateCaseRecord updates case record assignment and other mutable fields.
   * Deprecated: Use UpdateAssigned instead.
   *
   * @deprecated
   */
  updateCaseRecord(request: UpdateCaseRecordRequest): Promise<UpdateCaseRecordResponse>;
  /** CancelCaseRecord cancels a case record by its unique identifier. */
  cancelCaseRecord(request: CancelCaseRecordRequest): Promise<CancelCaseRecordResponse>;
  /** UpdateAssigned updates the assigned user for a case record. */
  updateAssigned(request: UpdateAssignedRequest): Promise<UpdateAssignedResponse>;
  /** UpdateOutputData updates the output data for a case record. */
  updateOutputData(request: UpdateOutputDataRequest): Promise<UpdateOutputDataResponse>;
  /** UpdateInputData updates the input data for a case record. */
  updateInputData(request: UpdateInputDataRequest): Promise<UpdateInputDataResponse>;
  /** UpdateDispositionCode updates the disposition code for a case record. */
  updateDispositionCode(
    request: UpdateDispositionCodeRequest,
  ): Promise<UpdateDispositionCodeResponse>;
  /** ExecuteAction executes a decision action on a case record. */
  executeAction(request: ExecuteActionRequest): Promise<ExecuteActionResponse>;
  /**
   * GetCaseCounts returns case counts based on filters.
   * workflow_id is passed as a query parameter.
   */
  getCaseCounts(request: GetCaseCountsRequest): Promise<GetCaseCountsResponse>;
  /** DeleteCaseRecord soft deletes a case record and triggers cascade deletion. */
  deleteCaseRecord(request: DeleteCaseRecordRequest): Promise<DeleteCaseRecordResponse>;
  /**
   * BulkDeleteCaseRecords soft deletes up to 10 case records in one request,
   * cancelling each case's workflow first (same per-case path as DeleteCaseRecord).
   */
  bulkDeleteCaseRecords(
    request: BulkDeleteCaseRecordsRequest,
  ): Promise<BulkDeleteCaseRecordsResponse>;
  /** CreateCaseRecordWithFax creates a case record with an optional fax document (PDF). */
  createCaseRecordWithFax(
    request: CreateCaseRecordWithFaxRequest,
  ): Promise<CreateCaseRecordWithFaxResponse>;
  /** MarkAsAdverseEvent marks a case record as an adverse event and triggers PQC workflow. */
  markAsAdverseEvent(request: MarkAsAdverseEventRequest): Promise<MarkAsAdverseEventResponse>;
  /** LinkToCase links a case record to a PQC case and triggers PQC workflow. */
  linkToCase(request: LinkToCaseRequest): Promise<LinkToCaseResponse>;
  /**
   * TriggerProcessRecording fires the process-recording signal to the case's
   * aepqc_preprocessing workflow so Hermes can download, transcribe, and attach
   * the recording (via PQCAgent /from-cxone). Used by the historical backfill
   * tooling to drive recording processing without going through the live
   * ingestion pipeline.
   */
  triggerProcessRecording(
    request: TriggerProcessRecordingRequest,
  ): Promise<TriggerProcessRecordingResponse>;
  /**
   * CloneCaseRecord creates a duplicate of an existing case record with the same parameters.
   * Retrieves the source case record data and creates a new case record using CreateCaseRecord.
   */
  cloneCaseRecord(request: CloneCaseRecordRequest): Promise<CloneCaseRecordResponse>;
  /**
   * MigrateCaseRecordToMedBV migrates a case record from medicare_human workflow to medbv workflow.
   * Creates a new case record in the target medbv workflow with mapped input data and links it to the source.
   */
  migrateCaseRecordToMedBv(
    request: MigrateCaseRecordToMedBVRequest,
  ): Promise<MigrateCaseRecordToMedBVResponse>;
  /**
   * StartCaseRecord triggers the workflow for a case record.
   * If the case is in "created" state, it starts the workflow.
   * If the case has already started and restart=true, it re-triggers the workflow.
   * Returns the Temporal workflow ID even if the workflow is already running.
   */
  startCaseRecord(request: StartCaseRecordRequest): Promise<StartCaseRecordResponse>;
  /**
   * WatchCaseRecords establishes a server-side streaming connection to watch for changes
   * on specified case records. The client provides a list of case record IDs to watch,
   * and the server streams back updates as they occur.
   * On HTTP, this endpoint uses Server-Sent Events (SSE) for streaming.
   */
  watchCaseRecords(request: WatchCaseRecordsRequest): AsyncIterable<WatchCaseRecordsResponse>;
  /**
   * GetCaseRecordTimeline retrieves the activity timeline for a case record.
   * Returns a paginated list of timeline events (state changes, assignments,
   * calls, notes, tasks, emails, etc.) ordered newest-first.
   */
  getCaseRecordTimeline(
    request: GetCaseRecordTimelineRequest,
  ): Promise<GetCaseRecordTimelineResponse>;
}

/**
 * AdminCaseRecordService provides admin-level case record operations:
 *   - Manual data correction / incident mitigation (write endpoints)
 *   - Cross-organization read-only search (read endpoint)
 * All endpoints are restricted to system-admin users with global scope.
 * See warning above for usage restrictions on the mitigation endpoints.
 */
export interface AdminCaseRecordService {
  /**
   * AdminUpdateSLA updates the SLA breach flag, workflow duration, and/or workflow completed timestamp on a case record.
   * All fields are optional — only provided fields are updated.
   *
   * MITIGATION ONLY: This endpoint directly overwrites SLA fields that are
   * normally computed by the workflow engine. Use only for correcting
   * data after incidents or migrations. Do not call from application code.
   */
  adminUpdateSla(request: AdminUpdateSLARequest): Promise<AdminUpdateSLAResponse>;
  /**
   * AdminUpdateCaseState updates the case state (and optionally workflow state)
   * of a case record, with optimistic locking and a required audit reason.
   * Added for LA-4605 case revival; mirrors the internal core UpdateState.
   */
  adminUpdateCaseState(request: AdminUpdateCaseStateRequest): Promise<AdminUpdateCaseStateResponse>;
  /**
   * AdminSearchCaseRecords searches case records globally (across all
   * organizations and programs) on behalf of system administrators.
   *
   * Two modes:
   *   - ID lookup: provide case_record_ids and skip Atlas Search.
   *   - Atlas Search: provide field+value to autocomplete-match input_data
   *     fields, optionally narrowed by workflow_id, case_type_filter,
   *     assigned_user_ids, or created_at range.
   *
   * Both modes share the same response shape as the program-scoped
   * SearchCaseRecords RPC. Restricted to case_record:read:global.
   */
  adminSearchCaseRecords(
    request: AdminSearchCaseRecordsRequest,
  ): Promise<AdminSearchCaseRecordsResponse>;
  /**
   * AdminUpdateStatusFlags updates status flags on a case record.
   * All fields are optional — only provided fields are updated.
   *
   * MITIGATION ONLY: This endpoint directly overwrites status flags that are
   * normally managed by the workflow engine. Use only for correcting
   * data after incidents or migrations. Do not call from application code.
   */
  adminUpdateStatusFlags(
    request: AdminUpdateStatusFlagsRequest,
  ): Promise<AdminUpdateStatusFlagsResponse>;
}
